{
    "base_title": "The Reflection",
    "base_title_ru": "SkillsTrainer",
    "404_title": "Страница не найдена ⚠️",
    "404_description": "К сожалению мы не нашли то что вы искали",
    "404_home": "На главную",
    "401_title": "Доступ запрещен 🔐",
    "401_description": "У вас нет прав на просмотр данной страницы",
    "401_home": "На главную",
    "changes_saved": "Изменения сохранены",
    "coming_soon": "Раздел в разработке",
    "retry": "Повторить",
    " ": " ",
    "select_date_and_time": "Выберите дату и время",
    "select_date": "Выберите дату",
    "chat": "Чат",
    "menu": "Меню",
    "games": "Сессии",
    "tours": "Туры",
    "library": "Библиотека",
    "library-video": "Видео",
    "library-scorm": "Курсы",
    "library-documents": "Документы",
    "knowledge-base": "База знаний",
    "courses": "Курсы",
    "courses-page": {
        "title": "Курсы",
        "create": "Создать курс",
        "edit": "Редактировать курс",
        "empty": "Курсов пока нет",
        "fields": {
            "title": "Название",
            "description": "Описание",
            "documents-count": "Документы"
        },
        "headers": {
            "title": "Название",
            "description": "Описание",
            "documents": "Документы",
            "actions": "Действия"
        },
        "dialog": {
            "title-label": "Название",
            "description-label": "Описание",
            "documents-label": "Документы",
            "documents-placeholder": "Выберите документы базы знаний",
            "save": "Сохранить",
            "cancel": "Отмена"
        },
        "messages": {
            "created": "Курс создан",
            "updated": "Курс обновлён",
            "deleted": "Курс удалён",
            "error": "Что-то пошло не так"
        },
        "confirm-delete": "Удалить этот курс? Действие необратимо."
    },
    "ai-study-chat": "AI-чат обучения",
    "ai-study-chat-page": {
        "title": "AI-чат обучения",
        "new-conversation": "Новая беседа",
        "empty-sidebar": "Бесед пока нет",
        "empty-thread": "Выберите курс или сценарий, чтобы начать обучение",
        "untitled": "Новый чат",
        "input-placeholder": "Введите вопрос…",
        "send": "Отправить",
        "typing": "Ассистент печатает…",
        "sources": "Источники ({count})",
        "sources-label": "Источники",
        "score": "релевантность",
        "retry": "Повторить",
        "copy": "Копировать",
        "copied": "Скопировано",
        "failed": "Не удалось отправить",
        "search-placeholder": "Поиск по беседам",
        "search-empty": "Ничего не найдено",
        "empty": {
            "heading": "Готов помочь с обучением",
            "subtitle": "Спросите что угодно по материалам курса — я найду ответ в базе знаний и покажу источники."
        },
        "groups": {
            "today": "Сегодня",
            "yesterday": "Вчера",
            "earlier": "Ранее"
        },
        "composer": {
            "context": "Контекст:",
            "hint": "Ответы формируются ИИ по вашим материалам · Enter — отправить, Shift+Enter — перенос"
        },
        "quota": {
            "remaining": "Осталось сообщений: {count}",
            "exhausted": "Сообщения AI-чата закончились.",
            "unavailable": "AI-чат недоступен на вашем тарифе."
        },
        "new-dialog": {
            "title": "Новая беседа",
            "subtitle": "Выберите источник, по которому ИИ будет отвечать",
            "source-type": "Источник",
            "source-course": "Курс",
            "source-scenario": "Сценарий",
            "source-competency": "Компетенция",
            "pick-course": "Выберите курс",
            "pick-scenario": "Выберите сценарий",
            "pick-competency": "Выберите компетенцию",
            "pick-target": "Все игры или конкретная сессия",
            "all-games": "Все игры — мой прогресс",
            "all-games-sub": "Динамика оценок по компетенции",
            "back": "Назад",
            "no-games": "Нет завершённых игр",
            "empty-competencies": "Пока нет завершённых игр",
            "empty-competencies-hint": "Завершите игру по сценарию с компетенцией — и здесь появится разбор с ИИ",
            "empty-courses": "Пока нет доступных курсов",
            "empty-scenarios": "Пока нет доступных сценариев",
            "tag-game": "Игра",
            "search": "Поиск…",
            "search-empty": "Ничего не найдено",
            "start": "Начать",
            "cancel": "Отмена"
        },
        "stage": {
            "searching": "Ищу в материалах…",
            "reading": "Читаю источники…",
            "writing": "Пишу ответ…",
            "writing_sources": "Анализирую {count} фрагментов…",
            "summarizing_short": "Подытоживаю предыдущее",
            "searching_short": "Ищу в материалах",
            "reading_short": "Читаю источники",
            "writing_short": "Пишу ответ",
            "writing_sources_short": "Анализирую {count} фрагментов"
        },
        "suggestions-fallback": [
            { "title": "Кратко перескажи материалы", "subtitle": "Главное по теме" },
            { "title": "Составь план изучения", "subtitle": "С чего начать" },
            { "title": "Проверь меня вопросами", "subtitle": "Мини-тест" },
            { "title": "Объясни простыми словами", "subtitle": "Без терминов" }
        ],
        "suggestions-fallback-debrief": [
            { "title": "Разбери эту игру", "subtitle": "Главные выводы сессии" },
            { "title": "Что у меня получилось?", "subtitle": "Сильные стороны" },
            { "title": "Где я ошибся и почему?", "subtitle": "Точки роста" },
            { "title": "Что улучшить к следующей игре?", "subtitle": "Конкретные шаги" }
        ],
        "suggestions-fallback-progress": [
            { "title": "Как меняются мои результаты?", "subtitle": "Динамика по играм" },
            { "title": "Мои сильные и слабые навыки", "subtitle": "По оценкам игр" },
            { "title": "На чём сфокусироваться?", "subtitle": "Приоритет тренировок" },
            { "title": "Сравни первые и последние игры", "subtitle": "Что выросло" }
        ],
        "errors": {
            "send": "Не удалось отправить сообщение. Попробуйте ещё раз.",
            "quota": "Достигнут лимит сообщений.",
            "rate_limit": "Слишком много запросов. Подождите минуту и попробуйте снова.",
            "provider_unsupported": "Чат по базе знаний недоступен для текущего AI-провайдера вашей организации.",
            "generic": "Что-то пошло не так."
        }
    },
    "scenarios": "Сценарии",
    "competencies": "Компетенции",
    "competencies-list": "Список",
    "skills": "Навыки",
    "home": "Главная",
    "home_player": "Участник",
    "player": "Участник",
    "home_expert": "Эксперт",
    "reports-analytics-tours": "Туры",
    "reports": "Отчеты",
    "skill_reports": {
        "skill_development_report": "Отчет по развитию навыков",
        "generate": "Сформировать",
        "generate_description": "Сформируйте подробный отчет по развитию навыков за выбранный период",
        "manager_description": "Формируйте отчеты по развитию навыков сотрудников вашей организации",
        "date": "Дата",
        "competence": "Компетенция",
        "period": "Период",
        "status_label": "Статус",
        "actions": "Действия",
        "employee": "Сотрудник",
        "view": "Открыть отчет",
        "download_pdf": "Скачать PDF",
        "no_reports": "Отчеты пока не сформированы",
        "data_not_available": "Данные отчета пока недоступны",
        "generation_failed": "Не удалось сформировать отчет",
        "retry": "Повторить",
        "rate_limit_exceeded": "Достигнут лимит формирования отчетов. Попробуйте позже.",
        "too_many_pending": "Слишком много отчетов в обработке. Дождитесь завершения текущих.",
        "no_games_for_report": "За выбранный период и компетенцию не найдено завершённых сессий. Отчёт не может быть сформирован.",
        "report_already_exists": "Отчёт с такими параметрами уже существует. Проверьте список ниже.",
        "period_too_long": "Период отчета не должен превышать один год.",
        "invalid_parameters": "Проверьте компетенцию и период",
        "filter_by_employee": "Фильтр по сотруднику...",
        "batch": {
            "mode_single": "Один отчёт",
            "mode_batch": "Пакет",
            "load_employees": "Показать сотрудников",
            "sessions": "Сессий",
            "no_candidates": "За выбранный период и компетенцию нет сотрудников с завершёнными сессиями",
            "generate_selected": "Сформировать ({count})",
            "selected_limit": "За один раз можно выбрать не более {max} сотрудников",
            "progress": "Готово {ready} из {total}",
            "failed_count": "Ошибок: {count}",
            "status_unknown": "Статус неизвестен",
            "status_unknown_hint": "Отчёт не найден в списке — посмотрите таблицу отчётов ниже",
            "reused": "Отчётов переиспользовано: {count} — они сформированы за последние {hours} ч и не создавались заново",
            "reused_badge": "Переиспользован",
            "reused_on": "Сформирован {date}",
            "download_all": "Скачать всё",
            "toggle_details": "Показать состав пакета",
            "dismiss_confirm": "Пакет ещё формируется. Убрать его с экрана? Прогресс и кнопка «Скачать всё» будут потеряны, отчёты останутся в списке ниже.",
            "archive_unavailable": "Собрать архив не удалось: часть отчётов ещё не готова или уже недоступна",
            "archive_failed": "Не удалось скачать архив",
            "archive_building": "Собираем архив…",
            "archive_build_failed": "Не удалось собрать архив. Попробуйте ещё раз.",
            "candidates_failed": "Не удалось загрузить список сотрудников",
            "stale_selection": "Часть выбранных сотрудников больше недоступна. Список обновлён — выберите заново."
        },
        "quota": {
            "remaining_hour": "Лимит отчётов — {limit} в час, сейчас можно заказать ещё {remaining}. Уменьшите выбор или повторите в {time}.",
            "remaining_day": "Лимит отчётов — {limit} в сутки, сейчас можно заказать ещё {remaining}. Уменьшите выбор или повторите в {time}.",
            "exhausted_hour": "Лимит отчётов ({limit} в час) исчерпан. Он обновится в {time}.",
            "exhausted_day": "Лимит отчётов ({limit} в сутки) исчерпан. Он обновится в {time}.",
            "too_large_hour": "Лимит отчётов — {limit} в час. Выберите меньше сотрудников.",
            "too_large_day": "Лимит отчётов — {limit} в сутки. Выберите меньше сотрудников."
        },
        "status": {
            "pending": "В ожидании",
            "collecting_data": "Сбор данных...",
            "analyzing": "AI-анализ...",
            "generating_pdf": "Генерация PDF...",
            "ready": "Готово",
            "failed": "Ошибка"
        },
        "report": {
            "kicker": "Отчёт по развитию компетенции",
            "position": "Должность",
            "department": "Подразделение",
            "period": "Период",
            "games_count": "Кол-во сессий",
            "not_specified_f": "Не указана",
            "not_specified_n": "Не указано",
            "fig": {
                "your_average": "Ваш средний балл",
                "company_average": "Среднее по компании",
                "participants": "Участников за период",
                "skills_count": "Оценено навыков"
            },
            "sec": {
                "profile": "Профиль компетенции",
                "trend": "Динамика по сессиям",
                "strengths": "На что опираться",
                "priorities": "Три приоритета развития",
                "skills": "Разбор по навыкам",
                "plan": "План на три месяца"
            },
            "legend": {
                "you": "Ваш балл",
                "company": "Среднее по компании"
            },
            "dotplot_caption": "Отклонение от среднего — от превышения к отставанию",
            "trend_disclaimer": "Баллы сессий не сопоставимы напрямую: сложность кейсов от сессии к сессии различается. Снижение само по себе не означает спада навыка — график здесь наблюдение, а не вердикт.",
            "no_comparison": "Сравнение со средним по компании недоступно: за период по этой компетенции играли меньше трёх человек. Отчёт построен на абсолютных баллах.",
            "skill": {
                "works": "Что получается",
                "blocks": "Что мешает",
                "actions": "Что делать",
                "out_of_ten": "из 10",
                "company_short": "компания"
            },
            "level": {
                "outstanding": "Выдающийся результат",
                "strength": "Сильная сторона",
                "meets_standard": "На уровне компании",
                "needs_attention": "Требует внимания",
                "needs_development": "Зона развития"
            },
            "plan": {
                "month": "Месяц",
                "goals": "Цели",
                "actions": "Действия"
            },
            "colophon": {
                "built_on": "Отчёт построен по результатам сессий за период {from} — {to}. Всего сессий: {count}.",
                "comparison": "Сравнение — со средним по компании за тот же период. Участников: {count}."
            }
        }
    },
    "ranking": "Рейтинг",
    "analytics": "Аналитика",
    "support": "Поддержка",
    "users": "Пользователи",
    "participants": "Участники",
    "departments": "Отделы",
    "positions": "Должности",
    "user-custom-fields": "Кастомные поля",
    "administration": "Администрирование",
    "ai-assistants": "AI Ассистенты",
    "ai-prompts": "AI Промпты",
    "evaluation-rubrics": "Рубрики оценки",
    "ai-profiles": "AI Профили",
    "ai-connectors": "AI Подключения",
    "Audit logs": "Журналы аудита",
    "organizations": "Организации",
    "loading": "Загрузка...",
    "previous": "Назад",
    "next": "Вперёд",
    "save": "Сохранить",
    "copy": "Копировать",
    "copy_failed": "Не удалось скопировать автоматически. Выделите текст в поле и скопируйте вручную (Ctrl+C или ⌘C).",
    "confirm": "Подтвердить",
    "suggest": "Предложить",
    "generate": "Генерировать",
    "cancel": "Отменить",
    "close": "Закрыть",
    "search": "Поиск...",
    "accept": "Принять",
    "propose": "Предложить",
    "decline": "Отказаться",
    "send_request": "Отправить запрос",
    "assign": "Назначить",
    "actions": " ",
    "evaluators": {
        "ai": "AI",
        "expert": "Эксперт",
        "player": "Участник",
        "manager": "Администратор",
        "head": "Руководитель"
    },
    "statistics": {
        "date_from": "От",
        "date_to": "До",
        "competence": "Компетенция",
        "evaluator": "Экспертиза",
        "last_games_effectiveness": {
            "effectiveness": "Эффективность",
            "title": "Эффективность по сессиям"
        },
        "skill_trend": {
            "average_score": "Средняя оценка",
            "game": "Сессия",
            "score": "Оценка",
            "title": "Средняя оценка"
        },
        "player_competence_radar": {
            "title": "Статистика компетенций",
            "top": "Топ 10",
            "players_in_company": "Участников в компании",
            "by_games": "Аналитика по сессиям",
            "subtitle": "Общая статистика участника и компании",
            "filter": "Фильтр",
            "you": "Участник",
            "company": "Компания",
            "average_score": "средний балл",
            "skills_counted": "по {counted} из {total} навыков"
        },
        "personal_radar": {
            "title": "Мой радар компетенций",
            "subtitle": "Ваши навыки в сравнении со средним по организации"
        },
        "skill_gap_heatmap": {
            "title": "Тепловая карта дефицитов навыков",
            "no_data": "Нет данных оценок для выбранных фильтров"
        },
        "progress_over_time": {
            "title": "Прогресс во времени",
            "avg_score": "Средняя оценка",
            "week": "Неделя",
            "month": "Месяц",
            "no_data": "Нет данных за выбранный период"
        },
        "department_aggregation": {
            "title": "Сравнение департаментов",
            "avg_score": "Средняя оценка",
            "players": "Участники",
            "no_data": "Нет данных по департаментам для выбранных фильтров"
        },
        "employee_comparison": {
            "title": "Сравнение сотрудников",
            "subtitle": "Сравнение оценок навыков для 2-3 сотрудников",
            "select_players": "Выберите 2-3 участников для сравнения",
            "max_players": "Максимум 3 участника"
        },
        "score_distribution": {
            "title": "Распределение оценок",
            "subtitle": "Распределение оценок по компетенции или навыку",
            "count": "Оценки",
            "q1": "Q1",
            "median": "Медиана",
            "q3": "Q3",
            "average": "Среднее",
            "no_data": "Нет данных оценок для выбранных фильтров"
        },
        "evaluator_consistency": {
            "title": "Согласованность оценщиков",
            "subtitle": "Корреляция и средние оценки по типам оценщиков",
            "correlation": "Матрица корреляций",
            "correlation_method": "Пирсон",
            "avg_by_type": "Средняя оценка по типу оценщика",
            "pair_details": "Детали по парам",
            "corr_label": "Корр",
            "gap_label": "Разрыв",
            "shared_label": "Общие",
            "no_data": "Недостаточно данных оценок для расчета согласованности"
        },
        "engagement_dashboard": {
            "title": "Дашборд вовлеченности",
            "subtitle": "Отслеживайте интенсивность активности и сотрудников, которым требуется внимание",
            "active_employees": "Активные сотрудники",
            "avg_games_week": "Среднее сессий / неделю",
            "inactive_employees": "Неактивные сотрудники",
            "inactive_threshold_days": "Порог неактивности (дни)",
            "days_inactive": "Неактивен {days} дней",
            "last_game_date": "Последняя сессия: {date}",
            "no_games_yet": "Сессий пока не было",
            "no_inactive": "Неактивные сотрудники не найдены"
        },
        "strengths_weaknesses": {
            "title": "Сильные и слабые стороны",
            "subtitle": "Топ-3 сильных и слабых навыка",
            "strengths": "Сильные стороны",
            "weaknesses": "Зоны роста",
            "no_data": "Недостаточно данных для анализа"
        },
        "peer_percentile": {
            "title": "Перцентиль среди коллег",
            "subtitle": "Ваш ранг по навыкам относительно коллег в организации",
            "top_percent": "Топ {percent}%",
            "bottom_percent": "Низ {percent}%",
            "no_data": "Недостаточно данных коллег для расчета перцентиля"
        },
        "evaluation_gap": {
            "title": "Разрыв самооценки и AI-оценки",
            "subtitle": "Сравните самооценку с оценкой ИИ, чтобы выявить слепые зоны",
            "self_assessment": "Самооценка",
            "ai_evaluation": "Оценка ИИ",
            "gap": "Разрыв",
            "skill": "Навык",
            "no_data": "Нет данных - нужны и самооценки, и оценки ИИ"
        },
        "improvement_velocity": {
            "title": "Скорость улучшения",
            "subtitle": "Изменение оценки за последние 30 дней относительно предыдущих 30 дней",
            "no_data": "Недостаточно данных для расчета динамики",
            "improved": "Улучшилось",
            "declined": "Снизилось"
        },
        "activity_calendar": {
            "title": "Календарь активности",
            "subtitle": "Ежедневное участие в сессиях за последние 6 месяцев",
            "current_streak": "Текущая серия",
            "longest_streak": "Лучшая серия",
            "total_games": "Всего сессий",
            "games_count": "{count} сессий",
            "no_activity": "За последние 6 месяцев активности не было"
        },
        "session_history": {
            "title": "История сессий",
            "subtitle": "Ваши последние сессии и результаты",
            "date": "Дата",
            "scenario": "Сценарий",
            "type": "Тип",
            "score": "Оценка",
            "status": "Статус",
            "types": {
                "player_vs_player": "Участник против участника",
                "player_vs_ai": "Участник с ИИ",
                "training": "Тренировка"
            },
            "statuses": {
                "time_scheduling": "Согласование времени старта",
                "waiting_for_start": "Ожидает старта",
                "missed": "Пропущена",
                "in_progress": "В процессе",
                "protocol_approval": "Согласование протокола",
                "failed": "Неуспешно",
                "completed": "Завершена"
            }
        }
    },
    "org_activity": {
        "title": "Активность организаций",
        "empty": "Нет активности за этот период",
        "search_placeholder": "Поиск организаций…",
        "chips": {
            "today": "Сегодня",
            "week": "Неделя",
            "all": "Все",
            "inactive": "Неактивна ≥7д"
        },
        "sort": {
            "recent": "Последние",
            "least_active": "Наименее активные",
            "az": "А–Я"
        },
        "card": {
            "plays_in_7_days": "{count} игр за 7 дней",
            "open_menu": "Открыть меню",
            "open_audit_log": "Открыть журнал аудита"
        },
        "drawer": {
            "title": "Последняя активность",
            "open_audit_log": "Открыть полный журнал аудита",
            "active_for": "Активна {time} назад",
            "summary": "{games} игр · {scenarios} сценариев · {ai_profiles} AI-профилей",
            "buckets": {
                "today": "Сегодня",
                "yesterday": "Вчера",
                "this_week": "На этой неделе",
                "older": "Раньше"
            }
        },
        "events": {
            "game_created": "Игра сыграна",
            "voice_session_created": "Voice-сессия начата",
            "scenario_created": "Сценарий создан",
            "scenario_updated": "Сценарий обновлён",
            "ai_profile_created": "AI-профиль создан",
            "profile_created": "Новый сотрудник зарегистрирован"
        }
    },
    "participant": {
        "upcoming_games": "Ближайшие сессии",
        "for_rank_games": "Запрос оценки"
    },
    "roles": {
        "player": "Участник",
        "admin": "СуперАдмин(системный)",
        "scoped_admin": "Старший администратор",
        "observer": "Наблюдатель",
        "captain": "Капитан",
        "expert": "Эксперт",
        "lead_expert": "Старший эксперт",
        "manager": "Администратор",
        "support": "Поддержка",
        "early_access": "Ранний доступ",
        "head": "Руководитель",
        "candidate": "Кандидат"
    },
    "user-status": {
        "active": "Активен",
        "inactive": "Заблокирован",
        "pending": "Подтверждение"
    },
    "pagination": {
        "showing": "Показаны",
        "to": "-",
        "of": "из",
        "entries": "записей"
    },
    "validator": {
        "required": "Это обязательное поле",
        "library": "Размер файла должен быть менее 500МБ",
        "email": "Неправильный email",
        "password": "В пароле должна быть хотя бы одна строчная буква, число и спецсимвол. Минимум 8 символов.",
        "confirm": "Пароли не совпадают",
        "at_least": "Должно быть выбрано минимум",
        "items": "значения",
        "number": "В поле должно быть число",
        "is_odd": "Число должно быть четным",
        "number_between": "Введите число между",
        "number_and": "и",
        "date_range_required": "Диапазон обязателен",
        "invalid_date_range": "Неверный диапазон",
        "invalid_date_format": "Неверный формат даты",
        "start_date_after_end_date": "Дата начала должна быть раньше даты окончания",
        "max_180_days": "Максимум 180 дней"
    },
    "user": {
        "menu": {
            "settings": "Настройки",
            "statistics": "Статистика",
            "logout": "Выйти"
        }
    },
    "theme": {
        "system": "Системная",
        "light": "Светлая",
        "dark": "Темная"
    },
    "error": {
        "default": "Извините, произошла ошибка. Наши специалисты уже в курсе проблемы и исправят её в ближайшее время.",
        "unauthorized": "Ваша сессия истекла.",
        "contact-support": "Извините, произошла ошибка. Пожалуйста, свяжитесь с тех.поддержкой",
        "forbidden": "Доступ запрещен"
    },
    "confirmation": {
        "sure": "Вы уверены что хотите удалить запись?",
        "sure_return_to_time_scheduling": "Вы уверены что хотите вернуть сессию на этап согласования времени старта?",
        "sure_restore": "Вы уверены что хотите восстановить запись?",
        "sure_mark_completed": "Вы уверены, что хотите отметить эту сессию как завершённую?",
        "sure_mark_failed": "Перевести игру в неудачную и безвозвратно удалить все оценки и протокол участников?",
        "success": "Успешно!",
        "deleted": "Запись удалена",
        "failed_marked": "Игра переведена в неудачную",
        "restored": "Запись восстановлена",
        "cancel": "Действие отменено",
        "yes": "Да",
        "no": "Нет"
    },
    "dashboards": {
        "player": {
            "summary": {
                "welcome": "Добро пожаловать",
                "progress": "Ваш общий прогресс",
                "stats": {
                    "minutes": "Минут в сессии",
                    "effectiveness": "Эффективность",
                    "completed_games_count": "Успешных сессий",
                    "total_games_count": "Всего сессий"
                }
            },
            "cards": {
                "players_rating": {
                    "title": "Рейтинг вашей компании",
                    "player": "Участник",
                    "effectiveness": "Эффективность"
                }
            }
        },
        "head": {
            "my_stats": "Моя статистика",
            "subordinates": "Мои подчинённые",
            "subordinate_stats": "Статистика подчинённого",
            "select_subordinate": "Выберите подчинённого для просмотра статистики",
            "no_subordinates": "Подчинённые не назначены"
        }
    },
    "chat-page": {
        "last_game": "Последняя сессия",
        "chats": "Чаты",
        "no-chats": "Пусто",
        "contacts": "Контакты",
        "choose": "Выберите контакт",
        "send": "Отправить",
        "type": "Ваше сообщение...",
        "no-contacts": "Пусто",
        "search": "Поиск...",
        "start_conversation": "Начать диалог",
        "start_connecting": "Начните общаться с людьми, выбрав один из контактов слева."
    },
    "scenarios-page": {
        "title": "Название",
        "export-docx": "Экспорт .docx",
        "copy_title": "Копирование кейса",
        "generate_ai_title": "ИИ генерация кейса",
        "organization": "Организация",
        "competence": "Компетенция",
        "actions": " ",
        "add": "Добавить сценарий",
        "ai-generate": "ИИ генерация",
        "copy": "Копировать сценарий",
        "add_popup": "Добавление сценария",
        "delete": "Удалить сценарий",
        "edit": "Изменить сценарий",
        "edit_popup": "Изменение сценария",
        "industries": [
            "FMCG/розница",
            "Фармацевтика",
            "Банки и финтех",
            "Гостиницы и туризм",
            "IT-компании/SaaS",
            "Ресторанный бизнес/HoReCa",
            "E-commerce/маркетплейсы",
            "Производство/индустрия 4.0",
            "Логистика и T&L",
            "Телеком",
            "Образование/EdTech",
            "Химическая промышленность",
            "ПО для управления цепочками поставок",
            "Госсектор/некоммерческие организации"
        ],
        "case_types": [
            "Лидерство и People-Management",
            "Подбор и оценка персонала",
            "Продажи и клиент-сервис",
            "Переговоры и влияние",
            "Управление конфликтами",
            "Стратегия и исполнение"
        ],
        "cases": [
            [
                "Постановка целей SMART/OKR",
                "Дача развивающей обратной связи (SBI/COIN)",
                "Делегирование",
                "Коучинг GROW",
                "Performance Review",
                "Менторство"
            ],
            [
                "Интервью по компетенциям (CBI)",
                "Аттестация/ассессмент-центр",
                "Онбординг-сессия"
            ],
            [
                "Классическая продажа продукта/услуги",
                "Работа с возражениями",
                "Апселл/кросс-селл",
                "Обработка жалобы (претензии)",
                "M-channel продажа"
            ],
            [
                "Внутрикорпоративные переговоры о бюджете/ресурсах",
                "Контракт с клиентом/поставщиком",
                "Кризисные переговоры"
            ],
            [
                "Межличностный конфликт в команде",
                "Руководитель-подчинённый",
                "Конфликт ценностей/этики"
            ],
            [
                "Приоритизация портфеля проектов",
                "Управление изменениями",
                "Анализ рисков"
            ]
        ],
        "formats": [
            "1-1",
            "Команды"
        ],
        "labels": {
            "industry": "Отрасль",
            "case_type": "Тип кейса",
            "case": "Кейс",
            "format": "Формат",
            "duration": "Продолжительность (минуты)",
            "game_vs_ai": "Сессия с ИИ",
            "level": "Сложность",
            "competence": "Компетенция",
            "description": "Описание сценария",
            "description_hint": "Опционально опишите сценарий, который вы хотите сгенерировать (макс. 4000 символов)"
        },
        "generating_in_progress": "Генерация сценария, пожалуйста, подождите..."
    },
    "analytics-page": {
        "tours-page": {
            "tour": "Тур",
            "full_name": "Участник",
            "games_count": "Сессий",
            "team": "Команда",
            "export": "Экспорт",
            "effectiveness": "Эффективность"
        }
    },
    "report-filters": {
        "department": "Отдел",
        "position": "Должность",
        "employee": "Сотрудник",
        "scenario": "Сценарий",
        "competence": "Компетенция",
        "period": "Период",
        "reset": "Сбросить",
        "only-period-competence": "Учитываются только период и компетенция"
    },
    "competencies-page": {
        "title": "Название",
        "export-docx": "Экспорт .docx",
        "skills": "Навыки",
        "text": "Описание",
        "display_order": "Сортировка",
        "ai-assistant": "AI Ассистент",
        "language": "Язык",
        "department": "Департамент",
        "evaluation-format": "Формат оценки",
        "evaluation-format-skills": "Оценка по скиллам",
        "evaluation-format-checklist": "Бинарный чек-лист",
        "rubric": "Рубрика",
        "evaluation-target": "Кого оцениваем?",
        "evaluation-both": "Оба участника",
        "evaluation-team-a": "Только команда A",
        "evaluation-both-tooltip": "Оцениваются оба участника ‒ подходит для сценариев переговоров",
        "evaluation-team-a-tooltip": "Оценивается только руководитель ‒ формат обратной связи",
        "actions": " ",
        "add": "Добавить компетенцию",
        "add_popup": "Добавление компетенции",
        "delete": "Удалить компетенцию",
        "edit": "Изменить компетенцию",
        "edit_popup": "Изменение компетенции"
    },
    "faq-page": {
        "title": "Вопросы",
        "question": "Вопрос",
        "text": "Ответ",
        "is_shared": "Доступно для всех организаций",
        "actions": " ",
        "add": "Добавить вопрос",
        "add_popup": "Добавить вопрос",
        "delete": "Удалить вопрос",
        "edit": "Изменить вопрос",
        "edit_popup": "Изменить вопрос",
        "visibility": "Видимость",
        "visible_to_all": "Видно всем пользователям",
        "visible_to_managers": "Видно только менеджерам"
    },
    "ai-connectors-page": {
        "title": "AI Подключения",
        "is_shared": "Доступно для всех организаций",
        "actions": " ",
        "add": "Добавить подключение",
        "add_popup": "Добавить подключение",
        "delete": "Удалить подключение",
        "edit": "Изменить подключение",
        "edit_popup": "Изменить подключение",
        "label": "Название",
        "provider": "Провайдер",
        "service": "Сервис",
        "organization": "Организация",
        "status": "Статус",
        "region": "Регион",
        "endpoint": "Endpoint",
        "secret": "Пароль/Ключ",
        "maxConcurrency": "Максимальное кол-во соединений",
        "timeoutSec": "Таймаут",
        "sortOrder": "Порядок сортировки",
        "config": "Конфигурация",
        "modelPrimary": "Primary-модель",
        "modelLight": "Light-модель",
        "modelLightHint": "Пусто — используется Primary-модель",
        "folderId": "Folder ID",
        "models": "Модели",
        "is_default": "По умолчанию",
        "notes": "Заметки"
    },
    "skills-page": {
        "title": "Название",
        "display_order": "Сортировка",
        "competence": "Компетенция",
        "text": "Индикаторы",
        "actions": " ",
        "add": "Добавить навык",
        "add_popup": "Добавление навыка",
        "delete": "Удалить навык",
        "edit": "Изменить навык",
        "edit_popup": "Изменение навыка"
    },
    "departments-page": {
        "title": "Название",
        "actions": " ",
        "add": "Добавить отдел",
        "add_popup": "Добавление отдела",
        "delete": "Удалить отдел",
        "edit": "Изменить отдел",
        "edit_popup": "Изменение отдела"
    },
    "tours-page": {
        "title": "Название",
        "actions": " ",
        "add": "Добавить тур",
        "add_popup": "Добавление тура",
        "delete": "Удалить тур",
        "edit": "Изменить тур",
        "edit_popup": "Изменение тура"
    },
    "library-page": {
        "title": "Название",
        "text": "Описание",
        "video": "Видео",
        "courses": "Курсы",
        "video_link_copy": "Скопировать ссылку",
        "video_in_process": "Видео в обработке...",
        "is_public": "Доступно участникам",
        "actions": " ",
        "add": "Добавить видео",
        "add_popup": "Добавление видео",
        "delete": "Удалить видео",
        "edit": "Изменить видео",
        "edit_popup": "Изменение видео"
    },
    "library-documents-page": {
        "title": "Название",
        "actions": " ",
        "add": "Добавить документ",
        "add_popup": "Добавление документа",
        "delete": "Удалить документ",
        "edit": "Изменить документ",
        "edit_popup": "Изменение документа",
        "file": "Файл"
    },
    "scorm-page": {
        "title": "Название",
        "actions": " ",
        "add": "Добавить курс",
        "loading": "Курс загружается...",
        "add_popup": "Добавление курса",
        "delete": "Удалить курс",
        "edit": "Изменить курс",
        "edit_popup": "Изменение курса",
        "zip_file": "ZIP файл"
    },
    "ai-assistants-page": {
        "external_id": "ID",
        "description": "Описание",
        "actions": " ",
        "add": "Добавить ассистента",
        "add_popup": "Добавление ассистента",
        "delete": "Удалить ассистента",
        "edit": "Изменить ассистента",
        "edit_popup": "Изменение ассистента"
    },
    "ai-prompts-page": {
        "name": "Название",
        "content": "Содержимое",
        "actions": " ",
        "add": "Добавить промпт",
        "add_popup": "Добавление промпта",
        "delete": "Удалить промпт",
        "edit": "Изменить промпт",
        "edit_popup": "Изменение промпта",
        "key": "Ключ слота",
        "model": "Модель",
        "updated_at": "Обновлён",
        "custom": "Кастомный",
        "description": "Описание",
        "temperature": "Temperature",
        "top_p": "Top P",
        "reasoning_effort": "Усилие рассуждения",
        "reasoning_effort_default": "По умолчанию",
        "required_placeholders": "Обязательные плейсхолдеры (должны присутствовать в содержимом)",
        "versions": "История версий",
        "no_versions": "Версий пока нет",
        "restore": "Восстановить",
        "restore_confirm": "Восстановить эту версию? Её содержимое станет текущим.",
        "restored": "Версия восстановлена",
        "current_version": "Текущая",
        "author": "Автор",
        "error": "Что-то пошло не так.",
        "tab_system": "Системные",
        "tab_custom": "Кастомные",
        "system_hint": "Системные промпты используются кодом платформы. Их нельзя удалить, но можно редактировать содержимое.",
        "custom_hint": "Кастомные промпты подключаются к компетенциям и AI-профилям как переопределение промпта оценки.",
        "model_from_code": "задаётся кодом",
        "model_from_code_hint": "Модель выбирает код-потребитель промпта, в самом промпте она не хранится.",
        "used_by": "Используется",
        "used_by_value": "Компетенции: {competencies}, AI-профили: {profiles}",
        "not_used": "Не используется",
        "delete_blocked_hint": "Нельзя удалить: промпт используется как переопределение. {usage}",
        "slot_description": {
            "game_eval_negotiation": "AI-оценка PvP-игр: переговоры",
            "game_eval_feedback": "AI-оценка PvP-игр: обратная связь",
            "game_eval_vs_ai": "AI-оценка игр против AI (если у AI-профиля нет переопределения)",
            "protocol_evaluation": "Заполнение протокола сценария по транскрипту игры против AI",
            "voice_agent": "Системный промпт голосового AI-собеседника",
            "scenario_generation": "Генерация сценария по описанию",
            "scenario_card_update": "Обновление карточки сценария из AI-описания",
            "scenario_optimize": "Оптимизация AI-описания сценария",
            "skill_report_analysis": "Skill-отчёт: шаг анализа",
            "skill_report_recommendations": "Skill-отчёт: шаг рекомендаций"
        }
    },
    "evaluation-rubrics-page": {
        "name": "Название",
        "actions": " ",
        "add": "Добавить рубрику",
        "add_popup": "Добавить рубрику",
        "edit": "Редактировать рубрику",
        "edit_popup": "Редактировать рубрику",
        "delete": "Удалить рубрику",
        "updated_at": "Обновлено",
        "hint": "Рубрики задают бинарные чек-листы для оценки игр. Привяжите рубрику к компетенции, чтобы переключить её на оценку по чек-листу.",
        "used_by": "Используется",
        "used_by_value": "Компетенций: {count}",
        "not_used": "Не используется",
        "delete_blocked_hint": "Нельзя удалить: используется в {count} компетенциях.",
        "criteria": "Критерии",
        "criterion_text": "Критерий",
        "criterion_category": "Категория (необязательно)",
        "add_criterion": "Добавить критерий",
        "criteria_hint": "Перетаскивайте за ручку для изменения порядка. Группируйте связанные критерии одинаковой категорией.",
        "drag_to_reorder": "Перетащить",
        "no_criteria": "Добавьте хотя бы один критерий.",
        "versions": "История версий",
        "no_versions": "Версий пока нет",
        "criteria_count": "Критериев: {count}",
        "restore": "Восстановить",
        "restore_confirm": "Восстановить эту версию? Она станет текущей.",
        "restored": "Версия восстановлена",
        "current_version": "Текущая",
        "author": "Автор",
        "error": "Что-то пошло не так."
    },
    "ai-profiles-page": {
        "name": "Имя",
        "settings": "Настройки",
        "temperature": "Фантазия",
        "demeanor": "Характер и тон",
        "behavior": "Поведение, инструкции",
        "background": "Биография",
        "supportive_phrases": "Поддерживающие фразы",
        "ai_assistant": "AI ассистент",
        "ai_starts_first": "AI начинает первым",
        "first_phrase": "Первая фраза",
        "closing_phrases": "Завершающие фразы",
        "voice": "Голос",
        "expert_mode": "Экспертный режим",
        "custom_demeanor_hint": "Текущий кастомный характер и тон",
        "is_shared": "Доступно для всех организаций",
        "voice_options": {
            "male": "Мужской",
            "female": "Женский"
        },
        "demeanor_options": {
            "friendly": {
                "title": "Дружелюбный",
                "description": "Легко располагающий к себе и приятный в общении"
            },
            "critical": {
                "title": "Критичный",
                "description": "Часто указывает на недостатки и на то, что можно улучшить"
            },
            "empathetic": {
                "title": "Эмпатичный",
                "description": "Очень чутко относится к чувствам и эмоциям других"
            },
            "enthusiastic": {
                "title": "Энтузиаст",
                "description": "Проявляет сильный энтузиазм и рвение"
            },
            "analytical": {
                "title": "Аналитичный",
                "description": "Фокусируется на логике и детальном решении задач"
            },
            "curious": {
                "title": "Любопытный",
                "description": "Стремится узнавать новое и задавать вопросы"
            },
            "assertive": {
                "title": "Напористый",
                "description": "Уверенный в себе"
            },
            "blunt": {
                "title": "Прямолинейный",
                "description": "Говорит прямо и по делу"
            },
            "skeptical": {
                "title": "Скептичный",
                "description": "С осторожностью относится к новым решениям и идеям"
            },
            "neutral": {
                "title": "Нейтральный",
                "description": "Уравновешенный и объективный в стиле общения"
            },
            "casual": {
                "title": "Непринужденный",
                "description": "Непринужденный, разговорный тон"
            }
        },
        "placeholders": {
            "name": "Например: Сергей (вежливый и дружелюбный)",
            "demeanor": "Например: Дружелюбный, вежливый и общительный...",
            "background": "Например: Был уволен дважды...",
            "behavior": "Например: Не перебивает, активно слушает...",
            "first_phrase": "Например: Добрый день! Как ваше настроение?",
            "closing_phrases": "Например: У нас почти не осталось времени, поэтому предлагаю быстро подвести итоги нашей встречи."
        },
        "actions": " ",
        "add": "Добавить AI профиль",
        "add_popup": "Добавление AI профиля",
        "subtitle": "Как собеседник выглядит и звучит в сессии",
        "preview": {
            "title": "Превью",
            "unnamed": "Без имени",
            "voice": "голос {name}",
            "defaultVoice": "голос по умолчанию",
            "defaultPhoto": "Стандартное фото",
            "listen": "Послушать голос",
            "defaultVoiceNotice": "Голос подберётся в начале сессии — заранее послушать нельзя",
            "photoPlaceholder": "Фото появится здесь"
        },
        "delete": "Удалить AI профиль",
        "edit": "Изменить AI профиль",
        "edit_popup": "Изменение AI профиля",
        "avatar_hint": "изображение аватара",
        "avatar_save_first": "Сохраните профиль, чтобы загрузить аватар",
        "avatar_requirements": "Макс. 1 МБ • Рекомендуемое разрешение: 1536×1024 • Соотношение сторон: 3:2",
        "max_characters": "Не больше {max} символов"
    },
    "games-page": {
        "game-with-ai": "Сессия с ИИ",
        "organization": "Организация",
        "status": "Статус",
        "failure_reasons": {
            "protocol_not_agreed": "Протокол не согласован участниками",
            "protocol_approval_expired": "Время согласования протокола истекло",
            "annulled": "Сессия аннулирована",
            "expired": "Время сессии истекло",
            "assignment_changed": "Назначение курса в системе обучения изменилось"
        },
        "restore": "Восстановить",
        "play": "Начать",
        "meetings_unavailable": "Видеосессии между участниками временно недоступны. Попробуйте позже.",
        "import": "Импорт",
        "scenario": "Сценарий",
        "tour": "Тур",
        "game_types": {
            "classic": "1 - 1",
            "vs_ai": "AI",
            "uploaded_recording": "Запись"
        },
        "upload_recording": {
            "file": "Файл записи",
            "file_hint": "Видео или аудио, до 1 ГБ",
            "uploaded": "Файл загружен",
            "file_too_large": "Файл больше 1 ГБ",
            "upload_error": "Не удалось загрузить файл",
            "player": "Участник",
            "rate_both": "Оценить обоих участников",
            "second_player": "Второй участник",
            "open_session": "Открыть сессию"
        },
        "game_targets": {
            "user": "Участник",
            "position": "Должность",
            "department": "Отдел"
        },
        "number": "Номер",
        "start_up_to": "Начать до",
        "start_time": "Время старта",
        "teamA": "Команда A",
        "teamB": "Команда B",
        "others": "Участники",
        "actions": " ",
        "edit_results": "Изменить результаты",
        "add": "Добавить сессию",
        "add_popup": "Новая сессия",
        "delete": "Удалить сессию",
        "edit": "Редактировать сессию",
        "edit_popup": "Редактирование сессии",
        "time_scheduling": "Согласование времени старта",
        "return_to_time_scheduling": "Вернуться к согласованию времени старта",
        "preparation": "Подготовка к сессии",
        "view_scenario": "Посмотреть сценарий",
        "protocol": "Согласование протокола",
        "not_agreed": "Не согласовано",
        "expert-accept": "Принять и перейти к оценке",
        "expert-decline": "Отклонить",
        "hide_ai_results": "Скрыть оценку AI",
        "show_ai_results": "Показать оценку AI",
        "mark_completed": "Отметить как завершённую",
        "mark_failed": "Завершить неудачно",
        "popup": {
            "start_up_to": "Сыграть до",
            "target": "Кому назначить сессию?",
            "custom_field_value": "Значение поля «{field}»",
            "target_preview_count": "Будет создано сессий: {count}",
            "target_preview_empty": "Под этот срез не попадает ни один игрок — ни одна сессия создана не будет",
            "target_preview_limit_exceeded": "Это больше, чем можно создать за одно назначение (не более {limit}). Уменьшите срез, число кейсов или число копий",
            "copies_per_player": "Копий каждого кейса на игрока",
            "position": "Должность",
            "department": "Отдел",
            "scenario": "Сценарий",
            "optional": "Опционально, можно не указывать",
            "protocol_time": "Время протокола",
            "protocol_time_hint": "В минутах",
            "preparation_time": "Время подготовки",
            "preparation_time_hint": "В минутах",
            "game_duration": "Продолжительность",
            "game_duration_hint": "В минутах",
            "is_team": "Для команд",
            "is_camera_required": "Камеры обязательны",
            "is_self_rated": "Возможна оценка себя",
            "is_each_other_rated": "Возможна оценка друг друга",
            "is_expert_rated": "Возможна оценка эксперта",
            "is_ai_rated": "Возможна оценка AI",
            "show_results": "Показывать результаты",
            "automatically": "автоматически",
            "manually": "вручную",
            "is_public_hint": "Любой наблюдатель сможет подключиться",
            "is_public": "Публичная сессия",
            "team_a": "Команда A",
            "team_b": "Команда B",
            "player_a": "Участник A",
            "player_b": "Участник B",
            "expert": "Эксперт",
            "observers": "Наблюдатели",
            "tour": "Тур",
            "search": "Поиск...",
            "choose_players": "Выберите участников",
            "choose_expert": "Выберите эксперта",
            "choose_observers": "Выберите наблюдателей",
            "choose_scenario": "Выберите сценарий",
            "choose_tour": "Выберите тур",
            "expert_empty": "Если не выбран, его сможет выбрать капитан",
            "captain": "Капитан",
            "": "",
            "protocol": {
                "title": "Согласование протокола",
                "target": "Крайнее значение",
                "await_approval": "Ожидайте согласования оппонента",
                "await_proposal": "Ожидайте предложения оппонента",
                "questions": "Вопросы для вашей команды",
                "questions_a": "Вопросы команды A",
                "questions_b": "Вопросы команды B",
                "not_agreed": "Не договорились",
                "not_agreed_confirm": "Сессия будет завершена неудачно, результаты не будут засчитаны. Действие необратимо.",
                "not_agreed_done": "Сессия завершена неудачно."
            },
            "start_time": {
                "title": "Время старта",
                "must_start_by": "Необходимо начать до"
            },
            "edit_results": {
                "title": "Изменение результатов"
            },
            "preparation": {
                "title": "Подготовка к сессии",
                "description": "Описание сессии",
                "description_team": "Описание для команды",
                "notes": "Ваши заметки"
            },
            "import": {
                "download_example": "Скачать пример",
                "title": "Импорт сессий",
                "button": "Загрузить",
                "label": "Excel файл",
                "file_size_error": "Размер файла должен быть менее 10 МБ"
            },
            "create_multi_scenario_games_immediately": "Все сессии будут созданы сразу",
            "create_multi_scenario_games_sequentially": "Сессии будут созданы последовательно (после успешного завершения каждой)"
        }
    },
    "ai-game": {
        "title": "Сессия с ИИ",
        "recording": "Запись",
        "ai": "ИИ",
        "you": "Вы",
        "ai_ready": "Готов",
        "camera_off": "Камера выключена",
        "stop_game": "Завершить",
        "start_game": "Начать",
        "mic_permission": "Пожалуйста, предоставьте разрешение на использование микрофона в настройках для начала сессии",
        "permissions_granted": "Разрешения успешно предоставлены!",
        "close": "Закрыть",
        "microphone_required": "Пожалуйста, предоставьте доступ к микрофону для начала сессии",
        "mic_required": "Включите микрофон для начала сессии",
        "mic_not_detected": "Звук пока не обнаружен — попробуйте говорить или проверьте микрофон",
        "permissions_needed": "Доступ к микрофону обязателен. Камера — по желанию",
        "dialog_history": "История диалога",
        "agent": {
            "initializing": "Инициализация...",
            "listening": "Слушает",
            "thinking": "Думает...",
            "speaking": "Говорит",
            "waiting": "Ожидание агента..."
        },
        "waiting_for_start": "Начните сессию для начала диалога",
        "grant_microphone": "Предоставить доступ к микрофону",
        "game_not_found": "Сессия не найдена",
        "game_not_found_desc": "Сессия с ID {id} не найдена.",
        "confirm": {
            "start_question": "Вы уверены? Сессию нельзя будет приостановить",
            "start_title": "Сессия начата",
            "start_success": "Сессия успешно начата",
            "start_cancel_title": "Сессия не начата",
            "start_cancel_msg": "Начало сессии было отменено",
            "end_question": "Вы уверены? Сессия будет завершена",
            "end_title": "Сессия завершена",
            "end_success": "Сессия успешно завершена",
            "end_cancel_title": "Сессия не завершена",
            "end_cancel_msg": "Завершение сессии было отменено"
        },
        "voice": {
            "disconnected": "Отключено",
            "connecting": "Подключение...",
            "connection_lost_permanently": "Соединение потеряно. Сессия завершена из-за проблем с сетью.",
            "connected": "Подключено к серверу",
            "connection_error": "Не удалось подключиться к голосовому агенту",
            "game_already_finished": "Эта игра уже завершена",
            "connection_timeout": "Не удалось подключиться к голосовому серверу. Возможно, соединение блокируется файрволом или сетевыми ограничениями. Проверьте настройки сети и попробуйте снова.",
            "no_rooms_available": "Нет доступных комнат в данный момент. Пожалуйста, попробуйте позже.",
            "preparing_recording": "Готовим запись сессии, повторим через {seconds} с…",
            "recording_service_overloaded": "Сервис записи перегружен. Попробуйте через несколько минут.",
            "session_quota_exhausted": "Пакет сессий организации исчерпан. Обратитесь к менеджеру.",
            "connection_blocked": "Сеть заблокировала установку соединения с AI. Разрешите HTTPS (443) к доменам, затем повторите попытку.",
            "connection_blocked_signaling": "Файрвол или прокси вашей сети блокирует соединение с голосовым сервером. Попробуйте подключиться из другой сети или через мобильный хотспот.",
            "reconnecting": "Переподключение...",
            "disconnect_dialog_title": "Соединение потеряно",
            "disconnect_dialog_message": "Соединение было прервано. Хотите переподключиться или завершить сессию?",
            "disconnect_retry": "Переподключиться",
            "disconnect_finish": "Завершить сессию",
            "agent_join_timeout": "AI-агент не подключился вовремя. Попробуйте ещё раз.",
            "stop_failed": "Не удалось остановить сессию",
            "mic_enable_failed": "Не удалось включить микрофон. Попробуйте переключить его вручную.",
            "mic_toggle_failed": "Не удалось переключить микрофон",
            "camera_toggle_failed": "Не удалось переключить камеру",
            "duplicate_tab_title": "Сессия открыта в другой вкладке",
            "duplicate_tab_message": "Эта сессия уже активна в другой вкладке браузера. Закройте другую вкладку и откройте эту страницу заново, если хотите продолжить здесь.",
            "duplicate_tab_back": "Назад",
            "duplicate_tab_disconnect_title": "Открыто в другой вкладке",
            "duplicate_tab_disconnect_message": "Эта вкладка была отключена, потому что сессия уже активна в другой вкладке. Отсюда можно только вернуться на страницу сессии."
        },
        "pending_chunks_title": "Несохранённые данные записи",
        "pending_chunks_desc": "Есть несохранённые данные записи с предыдущей сессии. Хотите возобновить загрузку?",
        "pending_chunks_uploaded": "Все ожидающие записи успешно загружены",
        "resume_upload": "Возобновить загрузку",
        "skip": "Пропустить",
        "permissions_denied_safari": "Доступ к камере или микрофону был запрещен. Перейдите в Настройки Safari > Веб-сайты > Камера/Микрофон и разрешите доступ для этого сайта.",
        "supported": "Браузер поддерживается"
    },
    "positions-page": {
        "title": "Название",
        "actions": " ",
        "add": "Добавить должность",
        "add_popup": "Добавление должности",
        "delete": "Удалить должность",
        "edit": "Изменить должность",
        "edit_popup": "Изменение должности"
    },
    "user-custom-fields-page": {
        "title": "Название",
        "type": "Тип",
        "options_count": "Значений",
        "actions": " ",
        "add": "Добавить поле",
        "add_popup": "Добавление поля",
        "delete": "Удалить поле",
        "delete_confirm": "Удалить поле? Сохранённые у пользователей значения перестанут отображаться.",
        "edit": "Изменить поле",
        "edit_popup": "Изменение поля",
        "empty": "Кастомные поля ещё не созданы",
        "error": "Не удалось сохранить поле",
        "type_text": "Текст",
        "type_select": "Справочник",
        "type_locked_hint": "Тип нельзя изменить после создания поля",
        "options": "Значения",
        "options_hint": "Порядок значений здесь — порядок в выпадающем списке",
        "options_required": "Добавьте хотя бы одно значение",
        "option_title": "Значение",
        "option_add": "Добавить значение",
        "option_delete": "Удалить значение",
        "option_delete_confirm": "Удалить значение? У пользователей, которым оно выбрано, значение будет очищено.",
        "option_move_up": "Переместить вверх",
        "option_move_down": "Переместить вниз"
    },
    "organizations-page": {
        "name": "Название",
        "host": "Хост",
        "duel_limit": "Лимит сессий",
        "max_users": "Макс. пользователей",
        "max_users_hint": "0 = без ограничений",
        "max_vs_ai_games_per_scenario": "Максимум AI-игр на игрока по одному сценарию",
        "max_vs_ai_games_per_scenario_hint": "Пусто — без лимита. Действует для самостоятельного создания игр игроком",
        "employee_report_daily_limit": "Лимит отчётов по сотрудникам в сутки",
        "employee_report_daily_limit_hint": "Пусто — общий лимит платформы. Действует для администраторов и руководителей",
        "employee_report_hourly_limit": "Лимит отчётов по сотрудникам в час",
        "employee_report_hourly_limit_hint": "Пусто — общий лимит платформы. Действует для администраторов и руководителей",
        "registration": "Регистрация открыта",
        "timezone": "Регион",
        "locale": "Язык",
        "users_count": "Пользователи",
        "actions": " ",
        "add": "Добавить организацию",
        "add_popup": "Добавление организации",
        "delete": "Удалить организацию",
        "edit": "Изменить организацию",
        "edit_popup": "Изменение организации",
        "available_languages": "Доступные языки",
        "show_game_numbers_for_player": "Показывать номера сессий участникам",
        "allow_players_choose_expert": "Позволять участникам выбирать эксперта",
        "send_message": "Отправить сообщение менеджерам",
        "message": "Сообщение",
        "send": "Отправить",
        "clear_message": "Очистить сообщение",
        "current_message": "Текущее сообщение",
        "two_factor_available": "Двухфакторная аутентификация доступна",
        "two_factor_method": "Метод двухфакторной аутентификации",
        "two_factor_disabled": "Отключена",
        "two_factor_email": "Email",
        "two_factor_sms": "SMS",
        "hidden_menu_items": "Скрытые пункты меню",
        "hide_ai_results": "Скрыть результаты ИИ",
        "hide_player_rating": "Скрыть рейтинг компании от участников",
        "show_character_memory_to_player": "Показывать игроку память персонажа",
        "show_meeting_recap_to_player": "Показывать игроку итоги встречи",
        "create_user_on_external_launch": "Создавать пользователя при первом обращении внешней системы",
        "create_user_on_external_launch_hint": "Выключено — ученик, которого внешняя система приводит впервые, получит отказ вместо игры. Каждый созданный так пользователь занимает место в подписке.",
        "allow_external_email_linking": "Разрешить привязку внешнего пользователя по email",
        "allow_external_email_linking_hint": "Включено — внешний человек попадёт в уже существующего сотрудника, если внешняя система сообщила его адрес со своего сервера. Выключено — такой запуск отклоняется, и второй пользователь с тем же адресом не создаётся."
    },
    "users-page": {
        "import": "Импорт",
        "user": "Участник",
        "roles": "Роли",
        "effectiveness": "Эффективность",
        "department": "Отдел",
        "position": "Должность",
        "status": "Статус",
        "actions": " ",
        "add": "Добавить пользователя",
        "add_popup": "Добавление пользователя",
        "last_login_at": "Был онлайн",
        "delete": "Удалить",
        "view": "Посмотреть",
        "login": "Войти",
        "message": "Сообщение",
        "activate": "Разблокировать",
        "deactivate": "Заблокировать",
        "edit_popup": "Редактирование пользователя",
        "total_in_org": "Всего в организации",
        "multi_role_note": "Участник с несколькими ролями учтён в каждой плашке",
        "filter_role": "Роль",
        "all_roles": "Все роли",
        "filter_activity": "Проходил сценарии",
        "activity_played": "Да",
        "activity_not_played": "Нет",
        "filter_activity_from": "Проходил с даты",
        "filter_last_login_from": "Дата входа",
        "filter_custom_field": "Кастомное поле",
        "filter_custom_field_value": "Значение поля «{field}»",
        "last_login_never": "Не заходил",
        "last_login_since": "Заходил с даты",
        "cases_progress": "Пройдено кейсов",
        "cases_progress_value": "{completed} из {assigned}",
        "export": "Экспорт",
        "popup": {
            "name": "Имя",
            "last_name": "Фамилия",
            "patronymic": "Отчество",
            "phone": "Телефон",
            "timezone": "Временная зона",
            "language": "Язык",
            "country": "Страна",
            "invalid_phone": "Неправильный формат номера",
            "department": "Отдел",
            "position": "Должность",
            "effectiveness": "Эффективность",
            "roles": "Роли",
            "organizations": "Компании",
            "blocked": "Заблокирован",
            "is_active": "Активен",
            "email_verified": "Email подтвержден",
            "email_not_verified": "Email не подтвержден",
            "subordinates": "Подчинённые",
            "search_subordinates": "Поиск участников...",
            "import": {
                "download_example": "Скачать пример",
                "title": "Импорт пользователей",
                "button": "Загрузить",
                "label": "Excel файл",
                "marker_hint": "Для уже существующего пользователя пустая ячейка оставляет текущее значение, а прочерк (-) очищает поле.",
                "result_title": "Импорт запущен",
                "result_created": "Будет создано: {count}",
                "result_updated": "Будет обновлено: {count}",
                "result_skipped": "Пропущено: {count}",
                "result_skipped_row": "Строка {row}, {email}: {reason}",
                "result_truncated": "…и ещё пропущенных строк: {count}"
            }
        }
    },
    "users-ranking-page": {
        "user": "Участник",
        "roles": "Роли",
        "effectiveness": "Эффективность",
        "average-effectiveness": "Средняя за сессию",
        "sessions-count": "Сессий",
        "department": "Отдел",
        "position": "Должность",
        "status": "Статус",
        "export": "Экспорт",
        "actions": " "
    },
    "user-detail": {
        "games_finished": "Завершено сессий",
        "not_found": "Пользователь не найден",
        "games_total": "Всего сессий",
        "username": "Участник",
        "phone": "Телефон",
        "status": "Статус",
        "language": "Язык",
        "timezone": "Временная зона",
        "edit": "Редактировать",
        "department": "Департамент",
        "position": "Должность",
        "activate": "Активировать",
        "block": "Заблокировать",
        "account": {
            "title": "Аккаунт",
            "summary": {
                "title": "Общая информация",
                "games": "Всего сессий",
                "place": "Место в рейтинге",
                "effectiveness": "Эффективность",
                "time": "Время в сессии"
            }
        },
        "security": {
            "title": "Безопасность",
            "change_password_title": "Изменение пароля",
            "change_password": "Изменить пароль",
            "new_password": "Новый пароль",
            "confirm_new_password": "Подтвердите пароль",
            "password_requirements": "Требования к паролю:",
            "password_requirements_1": "Минимум 8 символов",
            "password_requirements_2": "Хотя бы одна строчная буква",
            "password_requirements_3": "Хотя бы одно число или символ"
        },
        "statistics": {
            "title": "Статистика"
        }
    },
    "game": {
        "character_memory": {
            "title": "Что персонаж помнит",
            "subtitle": "Память о прошлых встречах, с которой персонаж вышел на эту игру",
            "preview_subtitle": "Память ещё не зафиксирована — персонаж получит её в момент старта игры",
            "unavailable": "Прошлая встреча персонажу недоступна: он начнёт разговор, не помня о ней.",
            "agreements": "Договорённости",
            "player_commitments": "Обещания игрока",
            "character_commitments": "Обещания персонажа",
            "open_issues": "Открытые вопросы",
            "facts": "Названные факты",
            "attitude": "Отношение к игроку",
            "evaluation_passed": "Персонажу переданы результаты оценки той встречи",
            "evaluation_not_ready": "Оценка той встречи ещё не готова — персонаж получит её, когда она будет посчитана.",
            "evaluation_hidden": "Тексты оценки скрыты настройками организации.",
            "overall_effectiveness": "Общая эффективность",
            "outcome": {
                "deal": "Сделка",
                "partial": "Частично",
                "no_deal": "Без сделки",
                "unclear": "Итог неясен"
            }
        },
        "meeting_recap": {
            "title": "Итоги встречи",
            "outcome": "Итог встречи",
            "agreements": "Договорённости",
            "player_commitments": "Обещания игрока",
            "character_commitments": "Обещания персонажа",
            "open_issues": "Открытые вопросы",
            "facts": "Названные факты",
            "pending": "Итоги встречи ещё готовятся. Загляните сюда чуть позже.",
            "unavailable": "Построить итоги этой встречи не удалось.",
            "none": "По этой игре итогов нет."
        },
        "title": "Сессия",
        "team": "Команда",
        "expert": "Эксперт",
        "points": "баллов",
        "your_result": "Ваш результат",
        "joined_at": "Начало:",
        "ended_at": "Дата завершения",
        "min": "мин.",
        "duration": "Продолжительность",
        "from_average": "от средней",
        "ai_expert": "AI Эксперт",
        "ai_evaluation_in_progress": "AI-оценка выполняется",
        "delete_ai_request": "Удалить оценку AI",
        "ai_expert_refresh": "Обновить результаты AI",
        "ai_expert_refresh_rejected": {
            "evaluation_not_completed": "Сейчас обновить результаты AI нельзя: AI-оценка ещё выполняется.",
            "answer_pending": "Сейчас обновить результаты AI нельзя: ответ AI ещё не пришёл.",
            "recognition_pending": "Сейчас обновить результаты AI нельзя: запись ещё распознаётся.",
            "recognition_has_no_speech": "В записи не распознана речь: обновить результаты AI нельзя.",
            "recognition_has_too_little_speech": "В записи почти нет разговора участников — AI-оценка не выполнялась.",
            "no_ai_evaluation": "У этой сессии больше нет AI-оценки.",
            "game_evaluation_blocked": "Сессия не состоялась или аннулирована — AI-оценка недоступна."
        },
        "ai_expert_unavailable": {
            "recognition_has_no_speech": "В записи не распознана речь — AI-оценка не выполнялась.",
            "recognition_has_too_little_speech": "В записи почти нет разговора участников — AI-оценка не выполнялась.",
            "game_evaluation_blocked": "Сессия не состоялась или аннулирована — AI-оценка недоступна."
        },
        "ai_expert_refresh_failed": "Не удалось обновить результаты AI.",
        "speaker_mapping": {
            "title": "Участники и голоса",
            "voice": "Голос {number}",
            "unknown": "Не определено",
            "needs_review": "Проверьте участников",
            "needs_review_hint": "Участники могли быть определены неверно: убедитесь, что AI-оценка досталась нужным людям.",
            "failed": "Не удалось определить участников автоматически.",
            "unavailable": "Провайдер AI был недоступен: участники будут определены при следующей оценке.",
            "empty": "В расшифровке нет реплик, по которым можно определить участников.",
            "corrected_manually": "Исправлено вручную",
            "under_reevaluation": "Идёт AI-оценка с этими участниками. Пока она не закончится, на странице прежние результаты.",
            "confirm": "Участники верны",
            "review": "Проверить",
            "dialog_hint": "Назначьте участника каждому голосу. После сохранения AI-оценка будет запрошена заново.",
            "save": "Сохранить",
            "cancel": "Отмена",
            "confirmed": "Участники подтверждены",
            "fixed": "Участники исправлены, AI-оценка запрошена заново",
            "action_failed": "Не удалось выполнить действие"
        },
        "ai_expert_created": "Запущен процесс оценки сессии. Это занимает несколько минут. Вы можете покинуть страницу, так как мы пришлем вам уведомление, когда оценка будет доступна.",
        "expert_already_requested": "Оценка уже была запрошена другим участником",
        "request_expert": "Запрос Эксперта",
        "assign_expert": "Назначить Эксперта",
        "ai_process": "Подождите, идет обработка",
        "analyzing_results": "Идёт анализ результатов сессии...",
        "complete_expert_request": "Завершить оценку",
        "tabs": {
            "description": {
                "title": "Описание сценария",
                "subtitle": "Информация и правила сессии",
                "situation": "Ситуация",
                "your_role": "Ваша роль",
                "player_role": "Роль игрока: {name}",
                "team_tab": "Команда {team}",
                "empty": "У этой сессии нет описаний.",
                "load_error": "Не удалось загрузить описание. Попробуйте позже."
            },
            "results": {
                "title": "Результаты",
                "effectiveness_summary": "Эффективность по командам",
                "your_effectiveness": "Ваша эффективность",
                "parameters_section": "Параметры",
                "parameter": "Параметр",
                "target": "Крайнее значение",
                "coefficient": "Коэффициент",
                "value": "Договоренность",
                "points": "Баллы",
                "points_short": "баллов",
                "combinations": "Комбинации",
                "combination_bonus": "Бонус за комбинации",
                "questions": "Вопросы",
                "question": "Вопрос",
                "answer": "Ответ",
                "total": "Итого"
            },
            "comments": {
                "title": "Видеоанализ",
                "comments": "Комментарии",
                "no_comments": "Комментариев еще нет",
                "no_video": "Видео недоступно",
                "video_processing": "Видео обрабатывается...",
                "count": "комментариев",
                "delete": "Удалить",
                "edit": "Изменить",
                "popup": {
                    "add": "Добавление комментария",
                    "edit": "Изменение комментария",
                    "comment": "Комментарий",
                    "player": "Участник",
                    "all": "Всем"
                }
            },
            "feedback": {
                "title": "Оценка сессии",
                "no_feedback": "Оценок еще нет",
                "no_feedback_description": "Обратная связь по сессии еще не добавлена",
                "overall_score": "Общая оценка",
                "skills_evaluated": "Оценено навыков: {count}",
                "no_comment": "Комментарий не указан",
                "score_button": "Оценить участника",
                "player": "Участник",
                "author": "Автор",
                "download": "Скачать видео",
                "download_transcript": "Скачать стенограмму",
                "evaluators": {
                    "ai": "Эксперт",
                    "expert": "Эксперт",
                    "player": "Участник",
                    "manager": "Администратор",
                    "head": "Руководитель"
                },
                "popup": {
                    "score": {
                        "title": "Оценка участника",
                        "comment": "Комментарий",
                        "error": "Необходимо оценить все навыки участника",
                        "save_error": "Не удалось сохранить оценку. Возможно, у вас нет прав оценивать этого участника."
                    }
                }
            },
            "checklist": {
                "title": "Чек-лист",
                "total": "Пунктов пройдено",
                "pass": "Выполнено",
                "fail": "Не выполнено",
                "cannot_assess": "Невозможно оценить",
                "comment": "Общий комментарий",
                "category": "Категория",
                "author": "Оценщик",
                "player": "Участник",
                "passed_of": "{passed} из {total}",
                "evidence": "Подтверждение",
                "rationale": "Обоснование",
                "no_results": "Оценка по чек-листу ещё не готова",
                "no_results_description": "Эта сессия ещё не оценена по чек-листу"
            }
        }
    },
    "scenario": {
        "steps": {
            "information": {
                "create_new_ai_profile": "Создать новый",
                "edit_ai_profile": "Редактировать",
                "delete_ai_profile": "Удалить",
                "confirm_delete_ai_profile": "Вы уверены, что хотите удалить этот AI профиль?",
                "first_header": "Основные настройки",
                "second_header": "ИИ участник",
                "third_header": "Описание сценария",
                "next_scenario_label": "Следующий сценарий",
                "next_scenario_placeholder": "Не выбран",
                "next_scenario_hint": "После завершения сессии по этому сценарию, автоматически будет создана сессия по следующему.",
                "memory_header": "Связь со следующей встречей",
                "memory_group_evaluation": "Оценка следующей встречи",
                "memory_group_character": "Собеседник следующей встречи",
                "memory_pass_to_next": "помнит эту встречу",
                "memory_pass_to_next_hint": "Персонаж следующего сценария начнёт разговор как со знакомым: он получит краткое резюме этой встречи, договорённости, обещания сторон, открытые вопросы и названные факты. Запись разговора и дословные цитаты ему не передаются. Включайте, когда следующая встреча продолжает эту: второй раунд переговоров, регулярная встреча один на один.",
                "memory_pass_evaluation_to_next": "знает результаты её оценки",
                "memory_pass_evaluation_to_next_hint": "Вместе с памятью персонаж получит тексты обратной связи по навыкам и общий итог этой встречи и сможет вести себя как коуч, который помнит, что у игрока получилось.",
                "memory_evaluate_next_with_agreements": "учитывает договорённости этой встречи",
                "memory_evaluate_next_with_agreements_hint": "При оценке следующей встречи AI-эксперт увидит договорённости, обещания сторон и открытые вопросы этой и сможет проверить, выполнил ли игрок обещанное. Баллы и тексты прошлой оценки эксперту не передаются, чтобы не смещать новую.",
                "is_public": "Публичный",
                "is_public_hint": "Если включено — сценарий будет доступен для выбора участниками.",
                "title": "Сценарий",
                "subtitle": "Основная информация",
                "image": "изображение сценария",
                "field_title": "Название",
                "competence": "Компетенция",
                "description": "Описание",
                "description_a": "Описание для команды А",
                "description_b": "Описание для команды B",
                "ai_profile": "AI профиль",
                "ai_profile_placeholder": "Только для сессий с AI",
                "ai_description": "Описание для AI",
                "optimize_ai_description": "Оптимизировать с помощью ИИ",
                "optimizing_in_progress": "ИИ оптимизирует описание. Пожалуйста, подождите...",
                "optimize_error": "Не удалось оптимизировать описание. Попробуйте ещё раз.",
                "ai_description_hint": "Написание эффективного промпта требует опыта. Некачественный промпт может привести к непредсказуемому поведению сценария. Если вы не уверены — воспользуйтесь кнопкой «Оптимизировать с помощью ИИ», попробуйте автогенерацию сценариев или обратитесь к менеджеру за помощью.",
                "knowledge_base_header": "База знаний",
                "knowledge_base_documents": "Документы базы знаний",
                "knowledge_base_documents_hint": "Прикрепите документы для контекста AI-участника",
                "knowledge_base_no_documents": "Нет доступных документов. Загрузите документы на странице \"База знаний\".",
                "knowledge_base_chunks": "{count} фрагментов",
                "knowledge_base_purpose_voice": "AI-сессия",
                "knowledge_base_purpose_eval": "Оценка"
            },
            "settings": {
                "title": "Настройки",
                "subtitle": "Настройки сценария",
                "min_players": "Мин. участников",
                "min_players_hint": "Число между 2 и 20",
                "max_players": "Макс. участников",
                "max_players_hint": "Число между 2 и 20",
                "protocol_time": "Время заполнения протокола (мин)",
                "protocol_time_hint": "Число между 1 и 1440",
                "preparation_time": "Время подготовки (мин)",
                "preparation_time_hint": "Число между 0 и 1440. 0 - описание видно сразу",
                "game_duration": "Продолжительность сессии (мин)",
                "game_duration_hint": "Число между 1 и 60",
                "is_team": "Для команд",
                "is_camera_required": "Камеры обязательны",
                "is_self_rated": "Возможна оценка себя",
                "is_each_other_rated": "Возможна оценка друг друга",
                "is_expert_rated": "Возможна оценка эксперта",
                "is_ai_rated": "Возможна оценка AI",
                "show_results": "Показывать результаты",
                "automatically": "автоматически",
                "manually": "вручную"
            },
            "parameters": {
                "title": "Параметры",
                "subtitle": "Параметры для участников",
                "field_title": "Название",
                "team_a": "Команда A",
                "team_b": "Команда B",
                "player_a": "Участник A",
                "player_b": "Участник B",
                "points": "Значение",
                "ratio": "Коэффициент",
                "add": "Добавить параметр"
            },
            "questions": {
                "title": "Вопросы",
                "subtitle": "Вопросы участникам",
                "question": "Вопрос",
                "team": "Команда",
                "team_placeholder": "Выберите команду",
                "answers": "Ответы",
                "points": "Баллы",
                "select_answers": "Выберите ответы",
                "add_combination": "Добавить комбинацию",
                "add_question": "Добавить вопрос"
            },
            "next": "Вперед",
            "previous": "Назад",
            "save": "Сохранить"
        },
        "saved": "Сценарий сохранен",
        "to_list": "Назад к списку",
        "add_detail": "Добавление сценария",
        "edit_detail": "Редактирование сценария"
    },
    "notifications": {
        "title": "Уведомления",
        "mark_unread": "Отметить все непрочитанными",
        "mark_read": "Отметить все прочитанными",
        "delete_all": "Удалить все уведомления",
        "no_new": "Нет новых уведомлений",
        "system": "Система",
        "evaluation": {
            "ready": {
                "subject": "Оценка сессии #:gameNumber",
                "text": "Эксперт оценил сессию"
            }
        },
        "game": {
            "created": {
                "game_assigned": "Вам назначена сессия",
                "role": "Роль:"
            },
            "proposal": {
                "subject": "Согласование времени сессии",
                "time": "Время:",
                "description": "Пожалуйста, подтвердите или предложите свой вариант"
            },
            "agreed": {
                "subject": "Время сессии согласовано",
                "time": "Время:",
                "description": "Описание и возможность подготовки к сессии будут доступны за :preparationTime минут до начала",
                "description_zero": "Вы можете уже сейчас ознакомиться с описанием сценария и подготовиться"
            },
            "preparation": {
                "subject": "Подготовка к сессии",
                "text": "Открыта подготовка к сессии."
            },
            "started": {
                "subject": "Сессия #:gameNumber началась",
                "text": "Присоединяйтесь!"
            },
            "missed": {
                "subject": "Сессия #:gameNumber пропущена",
                "text": "Вы пропустили сессию"
            },
            "completed": {
                "subject": "Сессия #:gameNumber завершена",
                "text": "Успешная сессия"
            },
            "failed": {
                "subject": "Сессия #:gameNumber провалена",
                "text": "Завершена неудачно"
            },
            "results": {
                "proposed": {
                    "subject": "Согласование протокола сессии #:gameNumber",
                    "text": "Доступно согласование"
                },
                "declined": {
                    "subject": "Протокол сессии #:gameNumber отклонен",
                    "text": "Предложение отклонено"
                },
                "not_agreed": {
                    "subject": "Сессия #:gameNumber: стороны не договорились",
                    "text": "Капитан соперника отметил, что стороны не договорились. Сессия завершена неудачно, результаты не засчитаны."
                }
            },
            "meeting": {
                "ended-player": {
                    "subject": "Встреча по сессии #:gameNumber завершена",
                    "text": "Ожидайте результаты"
                },
                "ended-captain": {
                    "subject": "Встреча по сессии #:gameNumber завершена",
                    "text_fill": "Заполните протокол",
                    "text_wait": "Ожидайте заполнения протокола",
                    "protocol_time": "Время на протокол(мин): :protocolTime"
                }
            }
        }
    },
    "profile": {
        "avatar_allowed": "JPG, GIF или PNG. Максимальный размер: 2MB",
        "avatar_label_choose": "Выберите",
        "avatar_label_your_avatar": "свой аватар",
        "name": "Имя",
        "last_name": "Фамилия",
        "patronymic": "Отчество",
        "phone": "Телефон",
        "timezone": "Временная зона",
        "language": "Язык",
        "country": "Страна",
        "invalid_phone": "Неправильный формат номера",
        "save_changes": "Сохранить",
        "account": "Профиль",
        "security": "Безопасность",
        "statistics": "Статистика",
        "notifications": "Уведомления",
        "change_password_title": "Изменение пароля",
        "change_password": "Изменить пароль",
        "current_password": "Текущий пароль",
        "new_password": "Новый пароль",
        "confirm_new_password": "Подтвердите пароль",
        "password_requirements": "Требования к паролю:",
        "password_requirements_1": "Минимум 8 символов",
        "password_requirements_2": "Хотя бы одна строчная буква",
        "password_requirements_3": "Хотя бы одно число или символ",
        "two_factor_title": "Двухфакторная аутентификация",
        "two_factor_description": "Добавьте дополнительный уровень защиты вашего аккаунта",
        "two_factor_org_enforced": "Двухфакторная аутентификация обязательна для вашей организации",
        "two_factor_method": "Метод аутентификации",
        "two_factor_disabled": "Отключена",
        "two_factor_email": "Email",
        "two_factor_sms": "SMS",
        "two_factor_save": "Сохранить настройки 2FA"
    },
    "auth": {
        "password": "Пароль",
        "new_password": "Новый пароль",
        "remember": "Запомнить меня",
        "timezone": "Временная зона",
        "forgot": "Забыли пароль?",
        "login": "Войти",
        "login_title": "Вход",
        "new_password_title": "Изменение пароля",
        "change_password": "Сохранить",
        "country": "Страна",
        "invalid_phone": "Неправильный формат номера",
        "privacy_policy_title": "Правила платформы",
        "privacy_policy_text": "Текст правил платформы...",
        "first_time": "Помните пароль?",
        "registration": "Создать аккаунт",
        "forgot_title": "Забыли пароль?",
        "forgot_description": "Введите email и мы отправим вам инструкцию для сброса пароля",
        "send_reset_link": "Отправить ссылку",
        "back_to_login": "Назад",
        "register": "Создать аккаунт",
        "name": "Имя",
        "last_name": "Фамилия",
        "patronymic": "Отчество",
        "phone": "Телефон",
        "enter_password": "Введите пароль",
        "confirm_password": "Подтвердите пароль",
        "not_first_time": "Уже есть аккаунт?",
        "agree_too": "Я согласен с",
        "privacy_policy": "правилами платформы",
        "accept": " Я согласен ",
        "password_validation": "Пароль должен состоять из заглавных, строчных букв, чисел, спецсимволов и быть длиннее 8 символов",
        "password_confirm_error": "Пароли не совпадают",
        "set_password": "Сохранить пароль",
        "reset_password": "Сброс пароля",
        "for": "для",
        "sign_in_to_for": "Вход в {app} для {org}",
        "registration_title": "Создание аккаунта",
        "verify_title": "Подтверждение email",
        "verify_head": "Подтвердите ваш email",
        "verify_description": "Мы отправили вам ссылку для активации.",
        "verify_new_link": "Ссылка для активации направлена вам повторно.",
        "verify_send": "Отправить повторно",
        "verify_spam": "Вы сделали слишком много запросов, повторите через минуту",
        "verify_logout": "Выйти",
        "two_factor_title": "Двухфакторная аутентификация",
        "two_factor_description_email": "Мы отправили код подтверждения на вашу электронную почту. Пожалуйста, введите код ниже.",
        "two_factor_description_sms": "Мы отправили код подтверждения на ваш номер телефона. Пожалуйста, введите код ниже.",
        "two_factor_code_label": "Код подтверждения",
        "two_factor_code_placeholder": "Введите 6-значный код",
        "two_factor_verify": "Подтвердить",
        "two_factor_resend": "Отправить код повторно",
        "two_factor_resend_success": "Новый код отправлен",
        "two_factor_back": "Вернуться к входу"
    },
    "filepond": {
        "upload": "Загрузите",
        "upload_complete": "Загружено",
        "uploading": "Загрузка",
        "loading": "Загрузка",
        "tap_to_cancel": "нажмите для отмены",
        "tap_to_undo": "нажмите для отмены",
        "upload_aborted": "Загрузка отменена",
        "file_too_large": "Файл слишком большой"
    },
    "text-editor": {
        "image": "Перетащите ваше изображение в редактор"
    },
    "webrtc": {
        "ready_to_start": "Ожидание старта",
        "connected": "Подключено",
        "connection_lost": "Соединение потеряно. Пожалуйста, попробуйте снова."
    },
    "device_settings": {
        "title": "Настройки аудио и видео устройств",
        "speaker": "Динамик/Аудиовыход",
        "refresh_devices": "Обновить устройства",
        "speaker_switch_unsupported": "Переключение динамика не поддерживается в этом браузере"
    },
    "device_setup": {
        "mic_level": "Уровень микрофона",
        "mic_on": "Вкл",
        "mic_off": "Выкл",
        "cam_on": "Вкл",
        "cam_off": "Выкл"
    },
    "device_test": {
        "title": "Проверка аудио устройств",
        "speaker_test": "Проверка динамика",
        "speaker_hint": "Нажмите кнопку, чтобы воспроизвести тестовый звук через выбранный динамик",
        "play_sound": "Воспроизвести звук",
        "playing": "Воспроизведение...",
        "speaker_success": "Звук воспроизведён ✓",
        "mic_test": "Проверка микрофона",
        "mic_hint": "Нажмите кнопку и говорите в микрофон, чтобы проверить его работу",
        "volume_level": "Уровень громкости",
        "speak_now": "Говорите...",
        "seconds_short": "с",
        "start_mic_test": "Проверить микрофон",
        "testing": "Проверка...",
        "test_again": "Проверить снова",
        "mic_success": "Микрофон работает корректно!",
        "mic_fail": "Обнаружена проблема с микрофоном",
        "mic_fail_hint": "Звук не обнаружен. Проверьте, что микрофон подключён, не выключен и правильно выбран в настройках."
    },
    "ai_assistant_types": {
        "type": "Тип",
        "negotiation": "Переговоры",
        "feedback": "Обратная связь",
        "ai_profile": "Сессия с ИИ"
    },
    "Login": "Вход",
    "UI Elements": "UI Elements",
    "Forms & Tables": "Forms & Tables",
    "Welcome": "Welcome",
    "Pages": "Pages",
    "Charts & Maps": "Charts & Maps",
    "Others": "Others",
    "Typography": "Typography",
    "Cards": "Cards",
    "Basic": "Basic",
    "Advance": "Advance",
    "Widgets": "Widgets",
    "Components": "Components",
    "Alert": "Alert",
    "Close Alert": "Close Alert",
    "Avatar": "Avatar",
    "Badge": "Badge",
    "Button": "Button",
    "Calendar": "Calendar",
    "Image": "Image",
    "Pagination": "Pagination",
    "Progress Circular": "Progress Circular",
    "Progress Linear": "Progress Linear",
    "Autocomplete": "Autocomplete",
    "Tooltip": "Tooltip",
    "Slider": "Slider",
    "Date Time Picker": "Date Time Picker",
    "Select": "Select",
    "Switch": "Switch",
    "Checkbox": "Checkbox",
    "Radio": "Radio",
    "Textarea": "Textarea",
    "Rating": "Rating",
    "File Input": "File Input",
    "Otp Input": "Otp Input",
    "Form Layout": "Form Layout",
    "Form Validation": "Form Validation",
    "Charts": "Charts",
    "Apex Chart": "Apex Chart",
    "Chartjs": "Chartjs",
    "Account Settings": "Account Settings",
    "User Profile": "User Profile",
    "FAQ": "FAQ",
    "Dialog Examples": "Dialog Examples",
    "Pricing": "Pricing",
    "List": "List",
    "Edit": "Edit",
    "Nav Levels": "Nav Levels",
    "Level 2.1": "Level 2.1",
    "Level 2.2": "Level 2.2",
    "Level 3.1": "Level 3.1",
    "Level 3.2": "Level 3.2",
    "Raise Support": "Raise Support",
    "Documentation": "Documentation",
    "Dashboards": "Dashboards",
    "Analytics": "Analytics",
    "Apps & Pages": "Apps & Pages",
    "Email": "Email",
    "Chat": "Chat",
    "Invoice": "Invoice",
    "Preview": "Preview",
    "Add": "Add",
    "User": "User",
    "View": "View",
    "Login v1": "Login v1",
    "Login v2": "Login v2",
    "Register v1": "Register v1",
    "Register v2": "Register v2",
    "Register": "Регистрация",
    "Forget Password v1": "Forget Password v1",
    "Forget Password v2": "Forget Password v2",
    "Forgot Password v1": "Forgot Password v1",
    "Forgot Password v2": "Forgot Password v2",
    "Forgot Password": "Forgot Password",
    "Reset Password v1": "Reset Password v1",
    "Reset Password v2": "Reset Password v2",
    "Reset Password": "Reset Password",
    "Miscellaneous": "Miscellaneous",
    "Coming Soon": "Coming Soon",
    "Not Authorized": "Not Authorized",
    "Under Maintenance": "Under Maintenance",
    "Error": "Error",
    "Statistics": "Statistics",
    "Actions": "Actions",
    "Access Control": "Access Control",
    "User Interface": "User Interface",
    "CRM": "CRM",
    "eCommerce": "eCommerce",
    "Icons": "Icons",
    "Chip": "Chip",
    "Dialog": "Dialog",
    "Expansion Panel": "Expansion Panel",
    "Combobox": "Combobox",
    "Textfield": "Textfield",
    "Range Slider": "Range Slider",
    "Menu": "Menu",
    "Snackbar": "Snackbar",
    "Tabs": "Tabs",
    "Form Elements": "Form Elements",
    "Form Layouts": "Form Layouts",
    "Authentication": "Authentication",
    "Page Not Found - 404": "Page Not Found - 404",
    "Not Authorized - 401": "Not Authorized - 401",
    "Server Error - 500": "Server Error - 500",
    "2": "2",
    "Forms": "Forms",
    "Timeline": "Timeline",
    "Disabled Menu": "Disabled Menu",
    "Help Center": "Help Center",
    "Verify Email": "Verify Email",
    "Verify Email v1": "Verify Email v1",
    "Verify Email v2": "Verify Email v2",
    "Two Steps": "Two Steps",
    "Two Steps v1": "Two Steps v1",
    "Two Steps v2": "Two Steps v2",
    "Custom Input": "Custom Input",
    "Extensions": "Extensions",
    "Tour": "Tour",
    "Register Multi-Steps": "Register Multi-Steps",
    "Wizard Examples": "Wizard Examples",
    "Checkout": "Checkout",
    "Create Deal": "Create Deal",
    "Property Listing": "Property Listing",
    "Roles & Permissions": "Roles & Permissions",
    "Roles": "Roles",
    "Simple Table": "Simple Table",
    "Tables": "Tables",
    "Data Table": "Data Table",
    "Permissions": "Permissions",
    "Apps": "Apps",
    "Misc": "Misc",
    "Wizard Pages": "Wizard Pages",
    "Form Wizard": "Form Wizard",
    "Numbered": "Numbered",
    "3": "3",
    "ecommerce": "ecommerce",
    "Ecommerce": "Ecommerce",
    "Editors": "Editors",
    "Front Pages": "Front Pages",
    "Landing": "Landing",
    "checkout": "checkout",
    "Payment": "Payment",
    "Swiper": "Swiper",
    "Product": "Product",
    "Category": "Category",
    "Order": "Order",
    "Details": "Details",
    "Customer": "Customer",
    "Manage Review": "Manage Review",
    "Referrals": "Referrals",
    "Settings": "Settings",
    "Overview": "Overview",
    "My Course": "My Course",
    "Course Details": "Course Details",
    "Academy": "Academy",
    "Logistics": "Logistics",
    "Dashboard": "Dashboard",
    "Fleet": "Fleet",
    "5": "5",
    "10": "10",
    "20": "20",
    "25": "25",
    "50": "50",
    "100": "100",
    "maintenance": "Обслуживание",
    "maintenance-page": {
        "title": "Настройки обслуживания",
        "notification_section": "Глобальное уведомление",
        "notification_placeholder": "Введите сообщение уведомления для всех пользователей",
        "notification_hint": "Это сообщение будет показано всем авторизованным пользователям как предупреждение",
        "games_section": "Блокировка сессий",
        "games_blocked_label": "Заблокировать новые сессии",
        "games_blocked_hint": "При включении пользователи не смогут создавать или начинать новые сессии. К текущим сессиям можно присоединиться.",
        "save": "Сохранить",
        "clear": "Очистить",
        "clear_confirm": "Вы уверены, что хотите очистить уведомление?",
        "last_updated": "Последнее обновление",
        "updated_by": "обновил(а)",
        "games_blocked_message": "Приносим извинения за неудобства. В настоящее время проводится обслуживание платформы. Проведение сессий временно недоступно."
    },
    "$vuetify": {
        "badge": "Badge",
        "noDataText": "Список пуст",
        "close": "Закрыть",
        "open": "открыть",
        "carousel": {
            "ariaLabel": {
                "delimiter": "delimiter"
            }
        },
        "dataFooter": {
            "itemsPerPageText": "На странице:",
            "itemsPerPageAll": "Все",
            "pageText": "{0}-{1} из {2}",
            "firstPage": "Первая",
            "prevPage": "Предыдущая",
            "nextPage": "Следующая",
            "lastPage": "Последняя"
        },
        "pagination": {
            "ariaLabel": {
                "root": "root",
                "previous": "previous",
                "next": "next",
                "first": "first",
                "last": "last",
                "currentPage": "currentPage",
                "page": "page"
            }
        },
        "input": {
            "clear": "clear",
            "appendAction": "appendAction",
            "prependAction": "prependAction",
            "counterSize": "counterSize",
            "otp": "otp"
        },
        "fileInput": {
            "counterSize": "counterSize"
        },
        "rating": {
            "ariaLabel": {
                "item": "item"
            }
        }
    },
    "subscription-plans": "Тарифные планы",
    "organization-subscriptions": "Подписки организаций",
    "subscription-plans-page": {
        "name": "Название",
        "description": "Описание",
        "period": "Период",
        "grace_days": "Льготные дни",
        "features": "Функции",
        "charges": "Лимит",
        "actions": " ",
        "add": "Добавить план",
        "add_popup": "Добавить план",
        "edit": "Редактировать план",
        "edit_popup": "Редактировать план",
        "delete": "Удалить план",
        "delete_confirm": "Вы уверены, что хотите удалить этот план?",
        "monthly": "Ежемесячно",
        "yearly": "Ежегодно",
        "permanent": "Бессрочно",
        "regular_games": "Обычные сессии",
        "ai_games": "AI сессии",
        "any_games": "Любые сессии",
        "ai_chat_messages": "Сообщения AI-чата",
        "organization": "Организация",
        "global_plan": "Глобальный",
        "periodicity": "Периодичность",
        "min_zero": "Должно быть >= 0",
        "min_one": "Должно быть >= 1"
    },
    "organization-subscriptions-page": {
        "organization": "Организация",
        "host": "Хост",
        "current_plan": "Текущий план",
        "status": "Статус",
        "expires_at": "Истекает",
        "actions": " ",
        "assign_plan": "Назначить план",
        "switch_plan": "Сменить план",
        "cancel_subscription": "Отменить подписку",
        "renew_subscription": "Продлить подписку",
        "cancel_confirm": "Вы уверены, что хотите отменить подписку?",
        "renew_confirm": "Вы уверены, что хотите продлить подписку?",
        "no_plan": "Нет плана",
        "active": "Активна",
        "cancelled": "Отменена",
        "expired": "Истекла",
        "immediately": "Переключить немедленно",
        "view_usage": "Просмотр использования",
        "usage": "Использование",
        "used_of": "{used} из {limit}",
        "add_ticket": "Добавить пакет",
        "initial_consumption": "Начальное потребление",
        "feature": "Функция",
        "charges": "Количество",
        "expired_at_optional": "Дата истечения (необязательно)",
        "active_tickets": "Активные пакеты",
        "no_expiry": "Бессрочно",
        "tickets_only": "Пакеты",
        "revoke_ticket": "Отозвать",
        "revoke_ticket_confirm": "Вы уверены, что хотите отозвать этот пакет?",
        "deduct": "Списание",
        "deduct_amount": "Количество",
        "deduct_confirm": "Списать использование"
    },
    "api-tokens": "API-токены",
    "api-tokens-page": {
        "select_user": "Пользователь",
        "select_user_hint": "Выберите пользователя, чтобы просматривать и управлять его API-токенами.",
        "no_users_found": "Пользователи не найдены",
        "no_tokens": "У этого пользователя нет API-токенов.",
        "token_name": "Название",
        "abilities": "Права",
        "ability": "Право",
        "created_at": "Создан",
        "last_used_at": "Последнее использование",
        "expires_at": "Истекает",
        "actions": " ",
        "issue_token": "Выпустить токен",
        "issue": "Выпустить",
        "issue_failed": "Не удалось выпустить токен",
        "token": "Токен",
        "plaintext_warning": "Скопируйте токен сейчас — он больше не будет показан.",
        "revoke": "Отозвать",
        "revoke_confirm": "Вы уверены, что хотите отозвать этот токен? Интеграции, использующие его, перестанут работать."
    },
    "subscription": {
        "current_plan": "Текущий план",
        "expires_at": "Истекает: {date}",
        "no_active_plan": "Нет активного плана подписки",
        "quota_warning": "Квота почти исчерпана",
        "regular_games": "Обычные сессии",
        "ai_games": "AI сессии",
        "any_games": "Любые сессии",
        "ai_chat_messages": "Сообщения AI-чата",
        "used_of": "{used} из {limit}",
        "remaining": "Осталось: {count}",
        "quota_exceeded": "Превышена квота",
        "tickets_only": "Пакеты кредитов",
        "session_package": "Пакет сессий",
        "games_available": "Сессии",
        "users": "Пользователи",
        "active_users": "Активные пользователи",
        "active_tickets": "Пакеты кредитов",
        "ticket_charges": "{charges} кредитов",
        "ticket_no_expiry": "Бессрочно",
        "unlimited": "Безлимит",
        "no_game_limits": "Нет ограничений на количество сессий"
    },
    "knowledge-base-page": {
        "title": "База знаний",
        "upload": "Загрузить документ",
        "search-placeholder": "Поиск по названию...",
        "filter-status": "Статус",
        "confirm-delete": "Вы уверены, что хотите удалить этот документ? Все связанные фрагменты будут удалены.",
        "no-documents": "Нет доступных документов",
        "status": {
            "processing": "Обрабатывается",
            "ready": "Готов",
            "failed": "Ошибка"
        },
        "headers": {
            "title": "Название",
            "type": "Тип",
            "size": "Размер",
            "chunks": "Фрагменты",
            "status": "Статус",
            "created": "Дата загрузки",
            "actions": "Действия"
        },
        "upload-dialog": {
            "title": "Загрузка документа",
            "name": "Название",
            "file": "Файл",
            "hint": "PDF, DOCX, TXT, CSV, XLSX (макс. 10 МБ)",
            "submit": "Загрузить"
        },
        "retry-success": "Документ отправлен на повторную обработку",
        "delete-success": "Документ удалён",
        "upload-success": "Документ загружен",
        "provider-unsupported": "База знаний недоступна для текущего AI-провайдера вашей организации."
    },
    "candidate-page": {
        "document_title": "Интервью",
        "greeting": "Здравствуйте, {name}!",
        "intro_lead": "{organization} приглашает вас пройти интервью с виртуальным собеседником на вакансию «{vacancy}».",
        "duration": "Интервью займёт около {minutes} мин.",
        "requirements_title": "Что понадобится",
        "requirement_mic": "Рабочий микрофон, лучше — наушники с микрофоном",
        "requirement_camera_required": "Включённая камера: для этого интервью она обязательна",
        "requirement_camera_optional": "Камера не обязательна, но с ней разговор проходит естественнее",
        "requirement_browser": "Компьютер и свежий Chrome, Edge или Safari",
        "requirement_network": "Стабильный интернет и тихое место, где вас не прервут",
        "continue": "Продолжить",
        "consent": {
            "accept": "Я ознакомился(-ась) с текстом и даю согласие на обработку персональных данных",
            "back": "Назад",
            "start": "Начать интервью"
        },
        "terminal": {
            "finished": {
                "title": "Спасибо!",
                "text": "Интервью завершено, результат передан рекрутеру — он свяжется с вами. Эту страницу можно закрыть."
            },
            "already_completed": {
                "title": "Интервью уже пройдено",
                "text": "По этой ссылке интервью уже завершено. Если нужно пройти его ещё раз, свяжитесь с рекрутером."
            },
            "not_found": {
                "title": "Ссылка не найдена",
                "text": "Возможно, в адресе опечатка или ссылка больше не действует. Проверьте письмо от рекрутера или свяжитесь с ним."
            },
            "session_conflict": {
                "title": "Вы вошли в другой аккаунт",
                "text": "Выйдите из текущего аккаунта или откройте ссылку в приватном окне браузера."
            },
            "link_revoked": {
                "title": "Доступ по ссылке закрыт",
                "text": "Рекрутер отозвал эту ссылку. Свяжитесь с ним, чтобы получить новую."
            },
            "link_expired": {
                "title": "Срок действия ссылки истёк",
                "text": "Свяжитесь с рекрутером, чтобы он выпустил новую ссылку."
            },
            "attempts_exhausted": {
                "title": "Попытки закончились",
                "text": "Все доступные попытки по этой ссылке использованы. Свяжитесь с рекрутером."
            },
            "unavailable": {
                "title": "Сейчас начать не получится",
                "text": "Попробуйте позже или свяжитесь с рекрутером."
            },
            "rate_limited": {
                "title": "Слишком много попыток",
                "text": "Подождите минуту и обновите страницу."
            },
            "aborted": {
                "title": "Интервью не началось",
                "text": "Обновите страницу и попробуйте ещё раз. Если не помогает — свяжитесь с рекрутером."
            },
            "generic": {
                "title": "Что-то пошло не так",
                "text": "Обновите страницу и попробуйте ещё раз. Если не помогает — свяжитесь с рекрутером."
            }
        }
    },
    "recruiting-page": {
        "title": "Подбор",
        "create": "Создать вакансию",
        "edit": "Редактировать вакансию",
        "empty": "Вакансий пока нет",
        "load_error": "Не удалось загрузить список вакансий",
        "retry": "Повторить",
        "back": "К списку вакансий",
        "open": "Кандидаты",
        "archive": "В архив",
        "no_expiry": "Без срока",
        "confirm_archive": "Отправить вакансию в архив? Выдавать по ней новые ссылки будет нельзя.",
        "headers": {
            "title": "Вакансия",
            "scenario": "Сценарий",
            "status": "Статус",
            "expires_at": "Действует до",
            "actions": "Действия"
        },
        "status": {
            "draft": "Черновик",
            "active": "Активна",
            "archived": "В архиве"
        },
        "dialog": {
            "title_label": "Название вакансии",
            "scenario_label": "Сценарий интервью",
            "scenario_placeholder": "Выберите сценарий для игры с ИИ",
            "scenario_hint": "Доступны только сценарии, пригодные для игры с ИИ",
            "status_label": "Статус",
            "expires_label": "Действует до",
            "expires_hint": "Пусто — вакансия без срока",
            "save": "Сохранить",
            "cancel": "Отмена"
        },
        "messages": {
            "created": "Вакансия создана",
            "updated": "Вакансия обновлена",
            "archived": "Вакансия отправлена в архив",
            "revoked": "Ссылка отозвана",
            "attempt_granted": "Кандидату добавлена ещё одна попытка",
            "copied": "Ссылка скопирована",
            "error": "Что-то пошло не так"
        },
        "candidates": {
            "title": "Кандидаты",
            "empty": "По этой вакансии ещё не выдано ни одной ссылки",
            "load_error": "Не удалось загрузить список кандидатов",
            "issue": "Выдать ссылку",
            "import": "Импорт из файла",
            "expired": "Истекла",
            "no_games": "Интервью не начиналось",
            "attempts": "{used} из {allowed}",
            "revoke": "Отозвать ссылку",
            "extra_attempt": "Дать ещё попытку",
            "open_result": "Открыть результат интервью",
            "confirm_revoke": "Отозвать ссылку кандидата? Доступ пропадёт сразу, в том числе к идущему интервью.",
            "confirm_extra_attempt": "Добавить кандидату ещё одну попытку?",
            "headers": {
                "candidate": "Кандидат",
                "link_status": "Ссылка",
                "invite": "Приглашение",
                "game_status": "Интервью",
                "attempts": "Попытки",
                "expires_at": "Ссылка действует до",
                "actions": "Действия"
            },
            "link_status": {
                "created": "Выдана",
                "opened": "Открыта",
                "in_progress": "Проходит интервью",
                "completed": "Интервью пройдено",
                "revoked": "Отозвана"
            },
            "invite_status": {
                "not_sent": "Не отправлялось",
                "queued": "В очереди",
                "sent": "Отправлено",
                "failed": "Не отправлено"
            },
            "invite_sent_at": "Почтовый сервис принял письмо {date}",
            "invite_failure": {
                "rejected": "Почтовый сервис не принял письмо — перешлите ссылку сами",
                "transport": "Сбой отправки — перешлите ссылку сами",
                "revoked": "Ссылка отозвана",
                "sending_disabled": "Отправка писем выключена",
                "blocked": "Адрес в стоп-листе — перешлите ссылку сами"
            }
        },
        "issue_dialog": {
            "title": "Выдать персональную ссылку",
            "name": "Имя",
            "last_name": "Фамилия",
            "email": "Email",
            "phone": "Телефон",
            "attempts": "Количество попыток",
            "expires_at": "Ссылка действует до",
            "expires_hint": "Пусто — срок берётся из вакансии",
            "submit": "Выдать ссылку",
            "close": "Закрыть",
            "result_title": "Ссылка выдана",
            "warning": "Скопируйте ссылку сейчас — она показывается ровно один раз. В базе хранится только её хэш, восстановить ссылку невозможно: потерянную придётся отозвать и выпустить заново.",
            "copy": "Скопировать",
            "copied": "Скопировано",
            "send_invite": "Отправить приглашение на {email}",
            "send_invite_no_email": "Отправить приглашение на email",
            "send_invite_blocked": "Адрес в стоп-листе — письмо не уйдёт",
            "invite_queued": "Приглашение поставлено в очередь на {email}",
            "invite_blocked": "Приглашение не отправлено: адрес {email} в стоп-листе. Перешлите ссылку сами"
        },
        "import_dialog": {
            "title": "Импорт кандидатов",
            "subtitle": "Каждая строка файла — один кандидат и одна персональная ссылка.",
            "file": "Файл со списком кандидатов",
            "columns": "Столбцы: Имя, Фамилия, Email, Телефон",
            "limits": "xlsx или CSV с разделителем «;», до 200 строк и 10 МБ",
            "size_error": "Файл больше 10 МБ",
            "download_example": "Скачать шаблон",
            "note_title": "Ссылки будут видны только в скачанном файле",
            "note_text": "Файл скачается сразу после импорта. В базе хранится только хэш ссылок — выгрузить их второй раз невозможно, сохраните файл.",
            "submit": "Импортировать",
            "cancel": "Отмена",
            "result_title": "Ссылки выданы",
            "result": "Выдано ссылок: {count}. Файл скачан.",
            "invites_blocked": "Не отправлено приглашений: {count}. Адреса в стоп-листе — перешлите ссылки этим кандидатам сами.",
            "saved_title": "Сохраните скачанный файл",
            "saved_text": "Это единственная копия ссылок: в базе хранится только их хэш. Потерянную ссылку можно только отозвать и выпустить заново.",
            "download_again": "Скачать файл ещё раз",
            "errors_title": "Отклонённые строки",
            "error_row": "Строка {row}: {error}",
            "errors_truncated": "…и ещё отклонённых строк: {count}. В списке показаны первые 50.",
            "send_invites": "Разослать приглашения кандидатам",
            "send_invites_hint": "Кандидатам без email письмо не отправляется"
        }
    },
    "recruiting": "Подбор",
    "ai-reports": "ИИ-отчёты",
    "ai-reports-page": {
        "title": "ИИ-отчёты",
        "subtitle": "Опишите отчёт словами — соберём спеку, покажем превью и выгрузим Excel.",
        "status": {
            "draft": "Черновик",
            "pending": "Собирается",
            "ready": "Готов",
            "failed": "Не собрался"
        },
        "list": {
            "title": "Мои отчёты",
            "new": "Новый отчёт",
            "empty": "Отчётов пока нет. Нажмите «Новый отчёт» и опишите, что показать.",
            "untitled": "Без названия",
            "delete": "Удалить отчёт",
            "delete_confirm": "Удалить отчёт вместе с собранным файлом?",
            "deleted": "Отчёт удалён"
        },
        "dialog": {
            "title": "Диалог",
            "open_dictionary": "Справочник данных",
            "placeholder": "Например: сколько игр провёл каждый отдел за последний квартал",
            "send": "Отправить",
            "empty_title": "Что показать в отчёте?",
            "empty_text": "Напишите обычными словами: какие данные, за какой период и в каком разрезе. Если чего-то не хватит — переспрошу.",
            "examples_title": "Например:",
            "examples": {
                "e1": "Сколько игр провёл каждый отдел за последний квартал",
                "e2": "Средний балл по навыкам в отделе продаж за 2026 год",
                "e3": "Сотрудники, которые не играли больше месяца",
                "e4": "Кандидаты по вакансиям и статусы их ссылок за последние 30 дней"
            },
            "thinking": "Собираю отчёт…",
            "waiting_hint": "Ответ появится здесь сам — обновлять страницу не нужно.",
            "retry": "Повторить",
            "dismiss": "Скрыть",
            "spec_ready": "Отчёт собран — проверьте превью ниже и соберите файл.",
            "stuck_title": "Кажется, мы ходим по кругу",
            "stuck_text": "Загляните в справочник данных и переформулируйте запрос словами оттуда — так быстрее, чем отвечать на ещё один уточняющий вопрос.",
            "rejected_title": "Такой отчёт пока не собрать",
            "reason": {
                "no_such_measure": "Такого показателя в наших данных нет. Посмотрите список показателей в справочнике.",
                "no_such_field": "Такого поля в наших данных нет. Посмотрите список полей в справочнике.",
                "cross_dataset": "Запрос требует данных сразу из двух витрин. Разбейте его на два отчёта.",
                "window_function": "Доли от общего, места в рейтинге и сравнение с предыдущим периодом пока не поддерживаются.",
                "other": "Запрос выходит за пределы доступных данных. Посмотрите справочник и попробуйте иначе."
            },
            "usage": {
                "employees": "нет сотрудников | {n} сотрудник | сотрудников: {n}",
                "games": "нет игр | {n} игра | игр: {n}",
                "scenarios": "нет сценариев | {n} сценарий | сценариев: {n}",
                "evaluations": "нет оценок | {n} оценка | оценок: {n}",
                "candidates": "нет кандидатов | {n} кандидат | кандидатов: {n}"
            },
            "option_created_at": "добавлено {date}"
        },
        "preview": {
            "title": "Превью",
            "no_report": "Выберите отчёт слева или начните новый.",
            "no_spec": "Опишите отчёт в диалоге — превью появится, как только запрос будет понят.",
            "spec_title": "Что будет в отчёте",
            "rows_hint": "Показаны первые {count} строк",
            "total": "Всего строк: {count}",
            "zero_rows": "По этому запросу нет ни одной строки. Расширьте период или снимите фильтры — пустой файл собирать незачем.",
            "zero_rows_hint": "Проверьте значения фильтров — возможно, по ним нет данных",
            "duplicate_rows": "В превью есть одинаковые строки: выбранные колонки не различают записи этой витрины. Проверьте, то ли значит одна строка отчёта, — возможно, не хватает различающей колонки.",
            "too_many_rows": "В отчёте {count} строк, максимум {max}. Сузьте период или добавьте фильтры: при превышении потолка файл не собирается вовсе, а не обрезается.",
            "generate": "Собрать файл",
            "regenerate": "Собрать заново",
            "queued": "Файл собирается — карточка обновится сама, когда он будет готов.",
            "failed": "Не удалось собрать отчёт",
            "download": "Скачать .xlsx",
            "downloads": "Скачиваний: {count}",
            "ttl_warning": "Файл хранится {days} дней, потом удаляется — скачайте его сразу.",
            "expires_at": "Доступен до {date}",
            "expired": "Файл удалён по сроку хранения — соберите отчёт заново."
        },
        "spec": {
            "dataset": "Данные",
            "columns": "Колонки",
            "measures": "Показатели",
            "group_by": "Разрез",
            "period": "Период",
            "period_value": "{field}: с {from} по {to}",
            "period_all": "Весь доступный период",
            "filters": "Отбор",
            "having": "Условия по показателям",
            "sort": "Сортировка",
            "limit": "Ограничение строк",
            "limit_value": "первые {count} строк",
            "granularity": {
                "year": "по годам",
                "quarter": "по кварталам",
                "month": "по месяцам",
                "week": "по неделям",
                "day": "по дням",
                "dow": "по дням недели"
            },
            "dir": {
                "asc": "по возрастанию",
                "desc": "по убыванию"
            },
            "filter": {
                "equals": "{field} — {value}",
                "not_equals": "{field} — не {value}",
                "in": "{field} — одно из: {value}",
                "not_in": "{field} — кроме: {value}",
                "gt": "{field} больше {value}",
                "gte": "{field} не меньше {value}",
                "lt": "{field} меньше {value}",
                "lte": "{field} не больше {value}",
                "contains": "{field} содержит «{value}»",
                "between": "{field} — с {from} по {to}",
                "is_null": "{field} не заполнено",
                "is_not_null": "{field} заполнено"
            }
        },
        "value": {
            "yes": "Да",
            "no": "Нет"
        },
        "dictionary": {
            "title": "Справочник данных",
            "subtitle": "Всё, что можно вытащить в отчёт. Список живой: он тот же, по которому собирается спека.",
            "fields": "Поля",
            "measures": "Показатели",
            "values": "Значения",
            "show_values": "Показать значения организации",
            "hide_values": "Скрыть значения",
            "values_error": "Не удалось загрузить значения — попробуйте ещё раз.",
            "values_empty": "У организации пока нет значений для этого поля.",
            "limits": {
                "title": "Чего отчёт не сделает",
                "pivot": "Сводная таблица «колонка на каждого участника» или «колонка на каждый вопрос» не соберётся. Закажите длинную: строка на каждую пару «участник — вопрос».",
                "window": "Отчёт не считает изменение месяц к месяцу, долю от общего, место в рейтинге и «по три лучших в каждом отделе». Возьмите разбивку по месяцам и досчитайте в Excel.",
                "missing": "Чего система не хранит, того в отчёте не будет: зарплаты, NPS и прочие данные из других систем не появятся ни под каким названием."
            },
            "empty": "Справочник пуст — обратитесь к администратору.",
            "close": "Закрыть"
        },
        "errors": {
            "generic": "Что-то пошло не так. Попробуйте ещё раз.",
            "detail": "Не понято: {value}",
            "rate_limit": "Слишком часто. Подождите минуту и повторите.",
            "download": "Не удалось скачать файл.",
            "turn_failed": "Не удалось получить ответ. Отправьте запрос ещё раз.",
            "turn_stuck_in_queue": "Запрос не дошёл до обработки — он слишком долго ждал в очереди. Отправьте его ещё раз.",
            "unknown_resolution": "Этот вариант устарел — заявка успела измениться. Откройте её заново и уточните запрос."
        }
    },
    "externalLaunch": {
        "document_title": "Тренировка",
        "intro": {
            "title": "Тренировочный разговор",
            "lead": "Сейчас вы поговорите с виртуальным собеседником. Разговор записывается и оценивается, результат вернётся в вашу систему обучения.",
            "requirements_title": "Что понадобится",
            "requirement_mic": "Рабочий микрофон, лучше гарнитура",
            "requirement_camera": "Камера не обязательна, но с ней разговор выходит живее",
            "requirement_browser": "Компьютер со свежим Chrome, Edge или Safari",
            "requirement_network": "Устойчивая связь и тихое место, где вас не прервут",
            "start": "Начать"
        },
        "relaunch_hint": "Вернитесь в систему обучения и запустите материал заново.",
        "saving": "Сохраняем результат…",
        "review": {
            "document_title": "Разбор встречи",
            "attempt": "Попытка {number}",
            "result": {
                "passed": "Зачтено",
                "failed": "Не зачтено",
                "pending": "Оценки пока нет"
            },
            "score_of_100": "{score} из 100",
            "threshold": "Проходной балл: {threshold}",
            "skills_title": "Навыки и рекомендации",
            "skills_empty": "По этой попытке пока нет разбора по навыкам.",
            "comments_title": "Комментарии к записи",
            "comments_empty": "Комментариев к этой записи нет.",
            "loading": "Загружаем разбор",
            "error": {
                "not_found": {
                    "title": "Ссылка не работает",
                    "text": "Разбор больше недоступен: срок ссылки истёк или попытка отозвана."
                },
                "expired": {
                    "title": "Страница устарела",
                    "text": "Откройте разбор заново по ссылке из системы обучения."
                },
                "generic": {
                    "title": "Не получилось показать разбор",
                    "text": "Что-то пошло не так на нашей стороне. Попробуйте открыть ссылку ещё раз."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Спасибо!",
                "text": "Разговор завершён. Результат появится в системе обучения, когда будет готова оценка. Эту страницу можно закрыть."
            },
            "aborted": {
                "title": "Разговор не начался",
                "text": "До начала разговора что-то пошло не так."
            },
            "token_expired": {
                "title": "Время доступа истекло",
                "text": "Доступ к этому разговору больше не действует."
            },
            "not_found": {
                "title": "Ссылка не работает",
                "text": "В адресе может быть опечатка, либо ссылка больше не действует."
            },
            "rate_limited": {
                "title": "Слишком много попыток",
                "text": "Подождите минуту и попробуйте снова."
            },
            "generic": {
                "title": "Сейчас начать не получится",
                "text": "На нашей стороне что-то пошло не так."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "Материал закрыт",
                "text": "Этот материал больше не доступен для тренировки."
            },
            "publication_draft": {
                "title": "Материал ещё не опубликован",
                "text": "Тренировку по этому материалу пока не открыли."
            },
            "publication_expired": {
                "title": "Срок материала истёк",
                "text": "Время, когда по этому материалу можно было тренироваться, закончилось."
            },
            "feature_disabled": {
                "title": "Материал закрыт",
                "text": "Запуск тренировок из системы обучения выключен в вашей организации."
            },
            "connection_disabled": {
                "title": "Материал закрыт",
                "text": "Связь с вашей системой обучения отключена. Обратитесь к тому, кто назначил курс."
            },
            "launch_limit_reached": {
                "title": "Лимит исчерпан",
                "text": "По этому материалу уже проведено максимальное число разговоров."
            },
            "daily_budget_exhausted": {
                "title": "На сегодня достаточно",
                "text": "Вы исчерпали число разговоров, разрешённых за сутки. Попробуйте завтра."
            },
            "attempts_exhausted": {
                "title": "Попытки закончились",
                "text": "Вы использовали все попытки, разрешённые по этому материалу."
            },
            "quota_exhausted": {
                "title": "Сейчас начать не получится",
                "text": "У вашей организации закончились доступные разговоры. Обратитесь к тому, кто назначил курс."
            },
            "user_limit_reached": {
                "title": "Сейчас начать не получится",
                "text": "В вашей организации нет свободных мест. Обратитесь к тому, кто назначил курс."
            },
            "scenario_unavailable": {
                "title": "Материал недоступен",
                "text": "Разговора, который стоит за этим материалом, больше нет."
            },
            "assignment_check_unavailable": {
                "title": "Сейчас начать не получится",
                "text": "Мы не смогли подтвердить, что этот материал назначен именно вам. Обратитесь к тому, кто назначил курс."
            },
            "code_invalid": {
                "title": "Ссылка больше не действует",
                "text": "Эта ссылка уже использована или её время истекло."
            },
            "channel_verification_failed": {
                "title": "Система обучения не ответила",
                "text": "Мы не смогли подтвердить запрос в вашей системе обучения."
            },
            "external_system_unavailable": {
                "title": "Система обучения не отвечает",
                "text": "Не получилось проверить назначение курса в системе обучения. Попробуйте ещё раз через несколько минут."
            },
            "user_not_found": {
                "title": "Мы не смогли вас опознать",
                "text": "Учётной записи для вас здесь нет, а автоматически их в вашей организации не создают. Обратитесь к тому, кто назначил курс."
            },
            "user_unavailable": {
                "title": "Ваша учётная запись отключена",
                "text": "Обратитесь к тому, кто назначил курс."
            },
            "user_deleted": {
                "title": "Ваша учётная запись удалена",
                "text": "Обратитесь к тому, кто назначил курс."
            },
            "email_taken_linking_disabled": {
                "title": "Мы не смогли вас опознать",
                "text": "Ваш адрес почты уже принадлежит другой учётной записи. Обратитесь к тому, кто назначил курс."
            },
            "service_role_not_allowed": {
                "title": "С этой учётной записью тренироваться нельзя",
                "text": "Администраторские учётные записи не проходят тренировки. Войдите под своей учебной."
            },
            "unverified_request": {
                "title": "Мы не смогли подтвердить запрос",
                "text": "Ваша система обучения не подтвердила, что разговор начали именно вы."
            }
        },
        "manage": {
            "nav": {
                "group": "Внешний запуск",
                "publications": "Публикации",
                "connections": "Подключения"
            },
            "messages": {
                "error": "Что-то пошло не так. Попробуйте ещё раз.",
                "load_error": "Не удалось загрузить данные."
            },
            "connections": {
                "title": "Подключения к системам обучения",
                "subtitle": "Аккаунты систем обучения, из которых организация запускает разговоры.",
                "create": "Добавить подключение",
                "edit": "Изменить",
                "set_credentials": "Задать учётные данные",
                "empty": "Подключений пока нет.",
                "secret_missing": "Не задан",
                "no_expiry": "Без срока",
                "headers": {
                    "account": "Аккаунт",
                    "base_url": "Адрес",
                    "client_id": "Идентификатор клиента",
                    "secret": "Секрет",
                    "status": "Статус",
                    "expires_at": "Срок учётных данных",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Без учётных данных",
                    "active": "Работает",
                    "expired": "Срок учётных данных истёк",
                    "disabled": "Выключено"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Новое подключение",
                    "edit_title": "Подключение",
                    "immutable_hint": "Система обучения и аккаунт не меняются: они задают пространство идентичностей ученика. Другой аккаунт — это новое подключение.",
                    "lms_label": "Система обучения",
                    "account_key_label": "Аккаунт",
                    "account_key_hint": "Идентификатор аккаунта в системе обучения.",
                    "base_url_label": "Адрес REST API iSpring",
                    "base_url_hint": "Например, https://api-learn.ispringlearn.ru. Это не адрес портала компании: по нему уйдёт секрет.",
                    "base_url_https": "Адрес должен начинаться с https://",
                    "enabled_label": "Подключение включено",
                    "enabled_hint": "Подключение не удаляется, а выключается. Публикации и запуски остаются в списках, но новые запуски отклоняются, а результаты в систему обучения больше не уходят.",
                    "credentials_optional": "Учётные данные необязательны. Без них подключение работает в ограниченном режиме.",
                    "client_id_label": "Идентификатор клиента",
                    "secret_label": "Секрет",
                    "secret_hint": "Хранится в шифрованном виде. Прочитать его назад нельзя — видны только четыре последних символа.",
                    "expires_at_label": "Срок учётных данных",
                    "expires_at_hint": "Оставьте пустым, если срока нет."
                },
                "credentials_dialog": {
                    "title": "Учётные данные",
                    "lead": "Новый секрет заменяет прежний. Подключение остаётся тем же, связи учеников и их запуски — на месте.",
                    "secret_hint": "Прежний секрет не нужен и прочитан быть не может."
                },
                "messages": {
                    "saved": "Подключение сохранено",
                    "credentials_saved": "Учётные данные сохранены"
                }
            },
            "publications": {
                "title": "Публикации",
                "subtitle": "Сценарии, открытые для запуска из системы обучения.",
                "create": "Новая публикация",
                "edit": "Изменить",
                "enable": "Включить",
                "disable": "Выключить",
                "open_journal": "Журнал",
                "download_package": "Скачать пакет",
                "empty": "Публикаций пока нет.",
                "no_connections": "Подключения к системе обучения ещё нет. Его заводит администратор платформы.",
                "no_expiry": "Без срока",
                "attempts_unlimited": "Без ограничения",
                "immutable_hint": "Подключение, сценарий и канал доставки не меняются: они вшиты в артефакт, уже загруженный в систему обучения. Всё остальное применяется без его пересборки.",
                "headers": {
                    "scenario": "Сценарий",
                    "connection": "Подключение",
                    "channel": "Канал",
                    "status": "Статус",
                    "settings": "Настройки",
                    "expires_at": "Срок",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Попыток: {value}",
                    "threshold": "Порог: {value}"
                },
                "status": {
                    "draft": "Черновик",
                    "active": "Открыта",
                    "disabled": "Выключена"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Только итог",
                    "status_and_score": "Итог и балл",
                    "status_score_and_review": "Итог, балл и ссылка на разбор"
                },
                "warnings": {
                    "limited_mode": "Ограниченный режим: балл и итог во внешней системе не появятся, проверка назначения не выполняется.",
                    "connection_disabled": "Подключение выключено: запуски по этой публикации не принимаются вовсе, пока администратор не включит подключение обратно.",
                    "assignment_check_off": "При выключенном флаге переназначение курса не обнаруживается.",
                    "no_course_binding": "Публикация не привязана к курсу — балл во внешнюю систему не попадёт."
                },
                "dialog": {
                    "connection_label": "Подключение",
                    "scenario_label": "Сценарий",
                    "channel_label": "Канал доставки",
                    "channel_hint": "Вшивается в артефакт и потом не меняется.",
                    "status_label": "Статус",
                    "status_hint": "Публикация не удаляется, а выключается. После этого новые запуски отклоняются, а ещё не отправленные результаты отменяются.",
                    "settings_section": "Настройки попытки",
                    "attempts_label": "Попыток на ученика",
                    "attempts_unlimited": "Без ограничения",
                    "daily_budget_label": "Запусков в сутки на ученика",
                    "daily_budget_hint": "Бережёт квоту: каждый начатый разговор списывает её и не возвращает.",
                    "result_mode_label": "Что уходит в систему обучения",
                    "pass_threshold_label": "Порог «сдал», 0–100",
                    "result_wait_label": "Ждать оценку, часов",
                    "result_wait_hint": "По истечении запуск доставит «результат не получен».",
                    "launch_limit_label": "Предел числа запусков",
                    "launch_limit_hint": "Оставьте пустым, если предела нет.",
                    "assignment_check_label": "Проверять назначение в системе обучения",
                    "binding_section": "Привязка в системе обучения",
                    "external_course_label": "Идентификатор курса",
                    "external_item_label": "Идентификатор элемента",
                    "expires_label": "Срок публикации",
                    "expires_hint": "Оставьте пустым, если срока нет."
                },
                "key_dialog": {
                    "title": "Публикация создана",
                    "warning": "Ключ показывается один раз и только здесь. Прочитать его потом нельзя ниоткуда — скопируйте сейчас и впишите в настройки артефакта. Потеряете — придётся заводить публикацию заново.",
                    "key_label": "Ключ публикации",
                    "copied": "Скопировано",
                    "package_hint": "Ключ уже внутри пакета — вписывать его никуда не нужно. Скачайте пакет и загрузите его в систему обучения. Скачать пакет снова можно в любой момент на странице публикаций."
                },
                "messages": {
                    "saved": "Публикация сохранена",
                    "enabled": "Публикация включена",
                    "disabled": "Публикация выключена",
                    "download_failed": "Не удалось скачать пакет. Обновите страницу и попробуйте ещё раз."
                }
            },
            "journal": {
                "title": "Журнал запусков",
                "unknown_scenario": "Сценарий недоступен",
                "back": "К публикациям",
                "revoke": "Отозвать попытку",
                "revoke_confirm": "Отозвать эту попытку? Ученик потеряет доступ к разговору, а неотправленные доставки будут отменены.",
                "retry_delivery": "Повторить",
                "empty_launches": "Запусков пока нет.",
                "empty_events": "Событий пока нет.",
                "no_deliveries": "У этой попытки доставок нет.",
                "not_held_quota_charged": "Не состоялась, квота списана",
                "relaunches": "возвратов: {value}",
                "last_launch": "последний запуск: {value}",
                "result_deadline": "Ждём оценку до {value}",
                "learner_contacts": "Адрес, присланный системой обучения: {email}. Запуск с адреса: {ip}",
                "score_passed": "{value} — сдал",
                "score_failed": "{value} — не сдал",
                "tabs": {
                    "launches": "Попытки",
                    "events": "События"
                },
                "headers": {
                    "learner": "Ученик",
                    "user": "Учётная запись",
                    "attempt": "Попытка",
                    "status": "Статус",
                    "game": "Разговор",
                    "started_at": "Начало",
                    "actions": " ",
                    "event_type": "Событие",
                    "refusal": "Причина",
                    "request_proof": "Подтверждение запроса",
                    "ip": "Адрес",
                    "user_agent": "Клиент",
                    "happened_at": "Когда"
                },
                "launch_status": {
                    "created": "Ссылка выдана",
                    "started": "Идёт",
                    "not_held": "Не состоялась",
                    "awaiting_result": "Ждём оценку",
                    "result_ready": "Результат доставлен",
                    "evaluation_failed": "Оценки нет",
                    "result_timed_out": "Срок ожидания истёк",
                    "assignment_changed": "Назначение изменилось",
                    "revoked": "Отозвана"
                },
                "delivery": {
                    "version": "Версия",
                    "status": "Статус",
                    "outcome": "Исход",
                    "result": "Результат",
                    "score": "Балл",
                    "attempts": "Попыток",
                    "last_attempt": "Последняя попытка",
                    "external_state": "Состояние в системе обучения"
                },
                "delivery_status": {
                    "pending": "В очереди",
                    "in_progress": "Отправляется",
                    "done": "Доставлена",
                    "needs_attention": "Требует внимания"
                },
                "delivery_outcome": {
                    "accepted": "Принято",
                    "confirmed": "Подтверждено",
                    "rejected_by_external": "Отклонено",
                    "retry": "Назначен повтор",
                    "cancelled": "Отменена",
                    "assignment_changed": "Назначение изменилось"
                },
                "result": {
                    "passed": "Сдал",
                    "failed": "Не сдал",
                    "not_held": "Не состоялась",
                    "no_result": "Результата нет"
                },
                "refusal": {
                    "publication_disabled": "Публикация выключена",
                    "publication_draft": "Публикация — черновик",
                    "publication_expired": "Срок публикации истёк",
                    "feature_disabled": "Внешний запуск выключен",
                    "connection_disabled": "Подключение выключено",
                    "launch_limit_reached": "Достигнут предел числа запусков",
                    "daily_budget_exhausted": "Исчерпан суточный бюджет",
                    "attempts_exhausted": "Попытки исчерпаны",
                    "quota_exhausted": "Квота организации исчерпана",
                    "user_limit_reached": "Свободных мест не осталось",
                    "scenario_unavailable": "Сценарий недоступен",
                    "assignment_check_unavailable": "Проверка назначения недоступна",
                    "code_invalid": "Ссылка использована или просрочена",
                    "channel_verification_failed": "Система обучения не подтвердила запрос",
                    "external_system_unavailable": "Система обучения не ответила на проверку назначения",
                    "user_not_found": "Учётной записи ученика нет",
                    "user_unavailable": "Учётная запись ученика отключена",
                    "user_deleted": "Учётная запись ученика удалена",
                    "email_taken_linking_disabled": "Адрес принадлежит другой учётной записи",
                    "service_role_not_allowed": "Служебная учётная запись не проходит разговоры",
                    "unverified_request": "Запрос не подтверждён"
                },
                "event_type": {
                    "launch_refused": "Запуск отклонён",
                    "exchange_refused": "Ссылка отклонена",
                    "exchange_succeeded": "Ссылка использована"
                },
                "request_proof": {
                    "unverified": "Не подтверждён",
                    "assignment_verified": "Назначение подтверждено"
                },
                "messages": {
                    "retry_queued": "Повтор поставлен в очередь",
                    "revoked": "Попытка отозвана"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Тренировка",
            "interview": "Интервью"
        },
        "load": {
            "loading": "Загружаем сессию…",
            "failed": "Не удалось загрузить сессию. Проверьте подключение и попробуйте ещё раз.",
            "scenarioFailed": "Сценарий не загрузился",
            "scenarioRetry": "Повторить"
        },
        "leave": {
            "confirm": "Разговор идёт. Если уйти со страницы, он не завершится, а время продолжит идти. Уйти?",
            "confirmEnd": "Разговор идёт. Если уйти, он завершится и будет оценён по тому, что успели. Уйти?"
        },
        "elsewhere": {
            "interviewTitle": "Интервью открыто в другой вкладке",
            "interviewText": "Интервью идёт в другой вкладке или на другом устройстве. Продолжайте его там, а эту вкладку можно закрыть.",
            "conversationTitle": "Разговор открыт в другой вкладке",
            "conversationText": "Разговор идёт в другой вкладке или на другом устройстве. Продолжайте его там, а эту вкладку можно закрыть."
        },
        "prep": {
            "header": {
                "backToSessions": "К сессиям",
                "themeToggleAriaLabel": "Переключить тему"
            },
            "scenario": {
                "sectionLabel": "Сценарий",
                "competenceLabel": "Оцениваемая компетенция",
                "gameNumber": "Сессия #{number}",
                "duration": "{minutes} мин",
                "readFull": "Читать полностью",
                "generalLabel": "Общая информация",
                "playerLabel": "Информация для вас"
            },
            "selfCamera": {
                "previewLabel": "Предпросмотр вашей камеры",
                "off": "Камера выключена"
            },
            "notes": {
                "empty": "Пусто"
            },
            "start": {
                "button": "Начать сессию",
                "interviewButton": "Начать интервью",
                "resumeButton": "Вернуться в разговор",
                "resumeHint": "Разговор уже идёт — время продолжает идти."
            }
        },
        "equipment": {
            "status": {
                "checking": "Проверяем оборудование",
                "waiting": "Ждём разрешения",
                "denied": "Доступ запрещён",
                "busy": "Устройство занято",
                "noCamera": "Камеры нет",
                "missing": "Микрофона нет",
                "dismissed": "Доступ не дан",
                "ready": "Оборудование готово"
            },
            "checking": {
                "title": "Проверяем микрофон и камеру…"
            },
            "waiting": {
                "title": "Разрешите доступ к микрофону",
                "cameraTitle": "Разрешите доступ к камере",
                "description": "Окно браузера с запросом уже открыто. Без микрофона разговор не начнётся."
            },
            "denied": {
                "title": "Браузер не пускает к микрофону",
                "cameraTitle": "Браузер не пускает к камере",
                "description": "Браузер запомнил запрет. Разрешите доступ к микрофону в настройках сайта и обновите страницу.",
                "cameraDescription": "Браузер запомнил запрет. Разрешите доступ к камере в настройках сайта и обновите страницу.",
                "showInstructions": "Показать, где это",
                "hideInstructions": "Скрыть",
                "chromeEdge": {
                    "browser": "Chrome и Edge",
                    "text": "Нажмите на значок замка слева от адреса страницы, откройте «Настройки сайта», разрешите «Микрофон» и обновите страницу."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Откройте меню Safari → «Настройки для этого веб-сайта», разрешите «Микрофон» и обновите страницу."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Нажмите на значок микрофона в адресной строке, снимите блокировку для этого сайта и обновите страницу."
                },
                "system": {
                    "title": "Система не пускает браузер к микрофону",
                    "cameraTitle": "Система не пускает браузер к камере",
                    "macos": "macOS: Системные настройки → Конфиденциальность и безопасность → Микрофон (или Камера) → включите браузер и перезапустите его.",
                    "windows": "Windows: Параметры → Конфиденциальность и защита → Микрофон (или Камера) → разрешите доступ приложениям и браузеру, затем нажмите «Повторить»."
                }
            },
            "busy": {
                "title": "Микрофон занят другой программой",
                "cameraTitle": "Камера занята другой программой",
                "description": "Обычно это созвон, оставшийся в фоне. Закройте его и нажмите «Повторить».",
                "retry": "Повторить"
            },
            "noCamera": {
                "title": "Камеры нет",
                "description": "Вас будет слышно, но не видно.",
                "requiredByScenario": "Этот разговор требует камеру. Подключите камеру, чтобы начать."
            },
            "missing": {
                "title": "Микрофон не найден",
                "description": "Подключите микрофон и нажмите «Повторить». Без микрофона разговор не начнётся."
            },
            "dismissed": {
                "title": "Доступ к микрофону не дан",
                "cameraTitle": "Доступ к камере не дан",
                "description": "Окно браузера закрыли без ответа. Нажмите «Повторить» и разрешите доступ."
            },
            "ready": {
                "title": "Оборудование готово"
            },
            "micLabel": "Микрофон",
            "cameraLabel": "Камера",
            "chooseMic": "Выбрать микрофон",
            "chooseCamera": "Выбрать камеру",
            "micLevelHint": "Скажите что-нибудь",
            "speakerValue": "Динамик: {name}",
            "configure": "Настроить",
            "dialog": {
                "title": "Оборудование",
                "lockedDuringConversation": "В разговоре устройства не меняются.",
                "micSelectLabel": "Микрофон",
                "cameraSelectLabel": "Камера",
                "speakerSelectLabel": "Динамик",
                "noCameraOption": "Без камеры",
                "record": "Записать 3 секунды",
                "recording": "Идёт запись…",
                "recordFailed": "Не удалось записать. Попробуйте ещё раз.",
                "listen": "Прослушать",
                "playing": "Воспроизведение…",
                "done": "Готово",
                "closeAriaLabel": "Закрыть диалог"
            },
            "unnamed": {
                "microphone": "Микрофон {number}",
                "camera": "Камера {number}",
                "speaker": "Динамик {number}"
            },
            "cameraWarmup": {
                "preview": "Камера включается",
                "title": "Микрофон готов",
                "description": "Камера догонит — обычно секунда-две.",
                "slowHint": "Камера не включается? Выберите другую в настройках."
            }
        },
        "recording": {
            "videoAndAudio": "Разговор и видео записываются.",
            "audioOnly": "Разговор записывается.",
            "accessSelfAndEvaluators": "Запись доступна вам и тем, кто оценивает вашу работу.",
            "accessEvaluators": "Запись доступна тем, кто оценивает вашу работу."
        },
        "scenario": {
            "video": "Видео от автора сценария"
        },
        "notes": {
            "title": "Заметки к сессии",
            "placeholder": "Что хотите отработать, какие формулировки заготовили",
            "saving": "Сохраняем…",
            "saved": "Сохранено",
            "saveError": "Не удалось сохранить",
            "visibility": "Заметки видны вам и тем, кто оценивает сессию.",
            "unsupported": "Заметки содержат элементы, которые здесь не редактируются. Они сохранены без изменений."
        },
        "stage": {
            "agentState": {
                "speaking": "Говорит",
                "listening": "Слушает",
                "thinking": "Думает"
            },
            "micOffWarning": "Микрофон выключен — собеседник вас не слышит",
            "micOnAriaLabel": "Выключить микрофон",
            "micOffAriaLabel": "Включить микрофон",
            "micOff": "Микрофон выключен",
            "micOnAnnouncement": "Микрофон включён",
            "captionsLabel": "Субтитры",
            "captionsOnAriaLabel": "Скрыть субтитры",
            "captionsOffAriaLabel": "Показать субтитры",
            "talkBalance": {
                "title": "Баланс речи",
                "you": "Вы",
                "interlocutor": "Собеседник"
            },
            "connectionQuality": {
                "excellent": "Отличная связь",
                "good": "Хорошая связь",
                "poor": "Слабая связь",
                "unknown": "Связь неизвестна"
            },
            "selfCameraLabel": "Вы",
            "timeWarning": {
                "lastMinute": "Минута до конца — пора сворачивать",
                "finalSeconds": "15 секунд — заканчивайте мысль"
            },
            "timeUp": {
                "title": "Время вышло",
                "text": "Разговор закроется сам, продлить его нельзя.",
                "closing": "Закрываем разговор…"
            },
            "voiceOnly": "Голосовой режим — видео у сценария нет",
            "interlocutorConnecting": {
                "title": "Собеседник подключается",
                "hint": "Обычно 2–4 секунды"
            },
            "layout": {
                "label": "Рядом",
                "sideTitle": "Разместить рядом",
                "focusTitle": "Собеседник крупно"
            }
        },
        "panels": {
            "scenario": "Сценарий",
            "transcript": "Транскрипт",
            "transcriptEmpty": "Здесь появятся законченные реплики.",
            "notes": "Заметки",
            "characterMemoryTab": "Что персонаж помнит",
            "openAriaLabel": "Открыть панель «{panel}»",
            "closeAriaLabel": "Закрыть панель «{panel}»"
        },
        "sound": {
            "label": "Звук",
            "volumeLabel": "Громкость",
            "speakerLabel": "Динамик"
        },
        "end": {
            "button": "Завершить",
            "confirmTitle": "Завершить разговор?",
            "elapsed": "Прошло {elapsed} из {total}.",
            "partialEvaluationNotice": "Разговор будет оценён по тому, что успели.",
            "continue": "Продолжить",
            "notSent": "Разговор завершится по времени: сервер не ответил на завершение."
        },
        "wait": {
            "title": "Готовим разговор",
            "hint": "Обычно это занимает 1–3 минуты. Не закрывайте страницу, начнём автоматически.",
            "nextTry": "Следующая попытка через {time}",
            "trying": "Пробуем начать…",
            "retrying": "Пока не получилось. Пробуем снова через {time}",
            "cancel": "Отменить",
            "failed": {
                "title": "Не удалось начать разговор",
                "text": "Сейчас нет свободных мест. Настройки микрофона и камеры сохранены, попробуйте снова через пару минут.",
                "retry": "Попробовать снова"
            }
        },
        "connection": {
            "reconnecting": "Связь потеряна, переподключаемся…",
            "restored": "Связь восстановлена",
            "failed": "Не удалось восстановить связь",
            "retry": "Повторить"
        },
        "hotkeys": {
            "title": "Горячие клавиши",
            "showHintAriaLabel": "Показать подсказку по клавишам",
            "micToggle": "Микрофон вкл/выкл",
            "scenarioPanel": "Сценарий: открыть и закрыть панель",
            "transcriptPanel": "Транскрипт",
            "notesPanel": "Заметки",
            "captionsToggle": "Субтитры вкл/выкл",
            "closeTopLayer": "Закрыть панель, поповер или диалог",
            "endConfirm": "Завершить — открыть подтверждение",
            "showHint": "Показать эту подсказку"
        },
        "intro": {
            "candidate": {
                "greeting": "Здравствуйте, {name}!",
                "leadWithVacancy": "{organization} приглашает вас пройти интервью с виртуальным собеседником на вакансию «{vacancy}».",
                "duration": "Интервью займёт около {minutes} мин.",
                "requirementsTitle": "Что понадобится",
                "requirementMic": "Рабочий микрофон, лучше — наушники с микрофоном",
                "requirementCameraRequired": "Включённая камера: для этого интервью она обязательна",
                "requirementCameraOptional": "Камера не обязательна, но с ней разговор проходит естественнее",
                "requirementBrowser": "Компьютер и свежий Chrome, Edge или Safari",
                "requirementNetwork": "Стабильный интернет и тихое место, где вас не прервут",
                "consentTextLabel": "Текст согласия",
                "consentAccept": "Я ознакомился(-ась) с текстом и даю согласие на обработку персональных данных",
                "next": "Далее"
            },
            "launch": {
                "title": "Тренировочный разговор",
                "lead": "Сейчас вы поговорите с виртуальным собеседником. Разговор записывается и оценивается, результат вернётся в вашу систему обучения.",
                "requirementsTitle": "Что понадобится",
                "requirementMic": "Рабочий микрофон, лучше гарнитура",
                "requirementCamera": "Камера не обязательна, но с ней разговор выходит живее",
                "requirementBrowser": "Компьютер со свежим Chrome, Edge или Safari",
                "requirementNetwork": "Устойчивая связь и тихое место, где вас не прервут",
                "start": "Начать"
            }
        },
        "finished": {
            "candidate": {
                "title": "Спасибо!",
                "text": "Интервью завершено. Результат передадут рекрутеру — он свяжется с вами. Эту страницу можно закрыть."
            },
            "launch": {
                "title": "Спасибо!",
                "text": "Разговор завершён. Результат появится в системе обучения, когда будет готова оценка. Эту страницу можно закрыть."
            }
        },
        "closeDialogAriaLabel": "Закрыть диалог"
    },
    "loopAvatars": {
        "title": "Аватары на петлях",
        "upload": "Загрузить аватар",
        "newVersion": "Новая версия",
        "newVersionHint": "«{name}», текущая версия {version}. Новый пакет заменит ролики во всех профилях с этим аватаром.",
        "edit": "Изменить аватар",
        "delete": "Удалить аватар",
        "empty": "Аватаров пока нет",
        "headers": {
            "poster": "Постер",
            "name": "Имя",
            "gender": "Пол",
            "emotion": "Эмоция",
            "visibility": "Видимость",
            "version": "Версия",
            "profiles": "Профили"
        },
        "gender": {
            "male": "Мужской",
            "female": "Женский"
        },
        "emotion": {
            "calm": "Спокойный",
            "friendly": "Дружелюбный",
            "strict": "Строгий"
        },
        "visibility": {
            "all": "Все организации"
        },
        "fields": {
            "package": "Пакет аватара (.zip)"
        },
        "packageHint": "ZIP до 100 МБ: manifest.json, listen.mp4, talk.mp4, transitions.json и poster.jpg",
        "validation": {
            "packageTooLarge": "Пакет должен быть не больше 100 МБ"
        },
        "errors": {
            "requestFailed": "Не удалось выполнить запрос. Попробуйте ещё раз."
        },
        "confirmDetach": "Будет отвязано профилей: {count}. Они перейдут на фото. Сохранить?",
        "confirmDelete": "Удалить аватар «{name}»?",
        "confirmDeleteWithProfiles": "Аватар «{name}» выбран в профилях: {count}. Они перейдут на фото. Удалить?"
    },
    "ttsVoices": {
        "title": "Голоса TTS",
        "create": "Добавить голос",
        "edit": "Изменить голос",
        "delete": "Удалить голос",
        "replaceSample": "Заменить образец",
        "replaceSampleHint": "«{name}», текущая версия образца {version}. Новый образец будет звучать во всех профилях с этим голосом.",
        "empty": "Голосов пока нет",
        "play": "Прослушать образец",
        "stop": "Остановить",
        "headers": {
            "name": "Название",
            "provider": "Провайдер",
            "externalId": "ID голоса",
            "gender": "Пол",
            "languages": "Языки",
            "visibility": "Видимость",
            "sample": "Образец",
            "profiles": "Профили"
        },
        "gender": {
            "male": "Мужской",
            "female": "Женский"
        },
        "visibility": {
            "all": "Все организации"
        },
        "fields": {
            "sample": "Образец голоса",
            "speed": "Скорость речи"
        },
        "sampleHint": "MP3, MP4 или M4A до 5 МБ",
        "sampleOptionalHint": "Можно не загружать — образец сгенерируется голосом по ID. MP3, MP4 или M4A до 5 МБ",
        "synthesizeSample": "Сгенерировать заново",
        "speedChangedHint": "Чтобы услышать новую скорость, сгенерируйте образец заново.",
        "speedSamplePromptTitle": "Скорость изменена",
        "speedSamplePrompt": "Образец всё ещё звучит на прежней скорости. Сгенерировать его заново? Текущий образец будет заменён.",
        "saveAndSynthesize": "Сохранить и сгенерировать",
        "saveOnly": "Только сохранить",
        "validation": {
            "sampleTooLarge": "Образец должен быть не больше 5 МБ"
        },
        "errors": {
            "requestFailed": "Не удалось выполнить запрос. Попробуйте ещё раз.",
            "sampleUnavailable": "Не удалось воспроизвести образец"
        },
        "confirmDetach": "Будет отвязано профилей: {count}. Они перейдут на голос коннектора. Сохранить?",
        "confirmDelete": "Удалить голос «{name}»?",
        "confirmDeleteWithProfiles": "Голос «{name}» выбран в профилях: {count}. Они перейдут на голос коннектора. Удалить?",
        "picker": {
            "none": "Голос по умолчанию",
            "empty": "В каталоге нет голосов этого пола",
            "loadError": "Не удалось загрузить голоса",
            "playSample": "Прослушать образец: {name}",
            "stopSample": "Остановить образец: {name}",
            "sampleUnavailable": "Образец недоступен"
        }
    },
    "realtimeAvatars": {
        "title": "Live-аватары",
        "create": "Добавить аватар",
        "edit": "Изменить аватар",
        "delete": "Удалить аватар",
        "preview": "Смотреть превью",
        "empty": "Аватаров пока нет",
        "headers": {
            "poster": "Постер",
            "name": "Название",
            "provider": "Провайдер",
            "externalId": "ID аватара",
            "gender": "Пол",
            "visibility": "Видимость",
            "profiles": "Профили",
            "models": "Модели Anam"
        },
        "gender": {
            "male": "Мужской",
            "female": "Женский"
        },
        "visibility": {
            "all": "Все организации"
        },
        "nameHint": "Можно не заполнять — возьмём имя из Anam",
        "externalIdHint": "При смене ID постер и превью загрузятся из Anam заново",
        "errors": {
            "requestFailed": "Не удалось выполнить запрос. Попробуйте ещё раз.",
            "previewUnavailable": "Не удалось воспроизвести превью"
        },
        "confirmDetach": "Будет отвязано профилей: {count}. Они перейдут на фото. Сохранить?",
        "confirmDelete": "Удалить аватар «{name}»?",
        "confirmDeleteWithProfiles": "Аватар «{name}» выбран в профилях: {count}. Они перейдут на фото. Удалить?",
        "picker": {
            "label": "Live-аватары",
            "empty": "Для этого профиля нет доступных Live-аватаров",
            "emptyFiltered": "Нет Live-аватаров этого пола",
            "loadError": "Не удалось загрузить Live-аватары"
        }
    },
    "aiProfileAppearance": {
        "label": "Внешность",
        "photo": "Своё фото",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Маскот",
        "filterGender": "Пол",
        "filterEmotion": "Эмоция",
        "avatarsLabel": "Аватары",
        "avatarRequired": "Выберите аватар",
        "liveRequired": "Выберите Live-аватар",
        "livePlaceholder": "Live-аватар появится здесь",
        "empty": "Для этого профиля нет доступных аватаров",
        "emptyFiltered": "Нет аватаров с такими фильтрами",
        "loadError": "Не удалось загрузить аватары",
        "playPreview": "Воспроизвести превью: {name}",
        "pausePreview": "Остановить превью: {name}"
    },
    "emailStopList": {
        "title": "Стоп-лист email",
        "description": "Письма на эти адреса и домены не отправляются. Запись домена закрывает все адреса этого домена, но не его поддомены.",
        "searchPlaceholder": "Поиск по адресу или домену",
        "allReasons": "Все причины",
        "add": "Добавить",
        "addTitle": "Заблокировать адрес или домен",
        "empty": "Стоп-лист пуст",
        "editNote": "Изменить заметку",
        "headers": {
            "type": "Тип",
            "value": "Адрес или домен",
            "reason": "Причина",
            "providerReply": "Ответ почтового сервиса",
            "note": "Заметка",
            "author": "Кто добавил",
            "createdAt": "Дата добавления",
            "blockedCount": "Остановлено писем",
            "lastBlockedAt": "Последнее остановленное"
        },
        "type": {
            "address": "Адрес",
            "domain": "Домен"
        },
        "reason": {
            "manual": "Вручную",
            "providerRejected": "Отказ почтового сервиса"
        },
        "author": {
            "system": "Система"
        },
        "fields": {
            "value": "Адрес или домен",
            "valueHint": "Укажите адрес целиком или только домен. Домен закрывает все свои адреса, но не поддомены.",
            "note": "Заметка"
        },
        "errors": {
            "requestFailed": "Не удалось выполнить действие. Попробуйте ещё раз."
        },
        "unblock": {
            "action": "Разблокировать",
            "confirm": "Разблокировать {value}?",
            "resultTitle": "Итог разблокировки",
            "result": {
                "removedEverywhere": "Разблокировано. В стоп-листе почтового сервиса адреса нет — письма снова будут уходить.",
                "removedLocally": "Домен разблокирован. Адреса этого домена, у которых есть своя запись, остаются заблокированными.",
                "providerNotConfigured": "Снята только запись платформы: связь с почтовым сервисом не настроена, его стоп-лист не проверялся.",
                "providerUnavailable": "Почтовый сервис недоступен, повторите позже. Адрес пока остаётся заблокированным.",
                "stillListedAtProvider": "Адрес в стоп-листе почтового сервиса. Снимите его в панели сервиса и нажмите «Разблокировать ещё раз». Если в панели адреса нет, он в глобальном стоп-листе сервиса, и снять его оттуда нельзя."
            },
            "openPanel": "Открыть панель почтового сервиса",
            "panelPath": "Где снять: панель почтового сервиса → Products → Email Service → ваш ресурс → вкладка Stop Lists.",
            "retry": "Разблокировать ещё раз"
        },
        "suggestions": {
            "text": "В домене {domain} заблокировано адресов: {count}. Заблокировать весь домен?",
            "block": "Заблокировать домен",
            "confirm": "Заблокировать домен {domain}? Письма на все его адреса перестанут уходить. Поддомены это не затронет, записи отдельных адресов останутся."
        },
        "check": {
            "title": "Проверить адрес",
            "hint": "Покажет, блокирует ли письма на адрес платформа или почтовый сервис",
            "placeholder": "Email-адрес",
            "submit": "Проверить",
            "resultFor": "Результат для {email}",
            "platform": "Стоп-лист платформы",
            "platformListed": "Да — запись «{value}»",
            "provider": "Стоп-лист почтового сервиса",
            "listed": "Да",
            "notListed": "Нет",
            "providerReasons": "Причины от почтового сервиса:",
            "providerNotConfigured": "Связь с почтовым сервисом не настроена",
            "providerUnavailable": "Почтовый сервис недоступен, повторите позже"
        }
    }
}
